
// import React, { useEffect, useState, useMemo } from 'react';
// import api from '../../services/api';
// import { useNavigate, useParams } from 'react-router-dom';
// import IndicatorDetailModal from '../../components/IndicatorDetailModal';
// import { useTheme as useCustomTheme } from '../../context/ThemeContext';

// /* ─── Font injection ─────────────────────────────────────────────── */
// if (typeof document !== 'undefined' && !document.getElementById('sr-fonts')) {
//   const link = document.createElement('link');
//   link.id = 'sr-fonts';
//   link.rel = 'stylesheet';
//   link.href =
//     'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=JetBrains+Mono:wght@400;600;700&display=swap';
//   document.head.appendChild(link);
// }

// /* ─── Design tokens ─────────────────────────────────────────────── */
// const T = {
//   ink:      '#0F172A',
//   ink2:     '#1E293B',
//   slate:    '#64748B',
//   muted:    '#94A3B8',
//   faint:    '#CBD5E1',
//   bg:       '#F8FAFC',
//   surface:  '#FFFFFF',
//   surface2: '#F8FAFC',
//   bdr:      '#E2E8F0',
//   bdr2:     '#CBD5E1',
//   red:    '#DC2626', redBg:  '#FEF2F2', redBdr:  '#FECACA',
//   amb:    '#B45309', ambBg:  '#FFFBEB', ambBdr:  '#FDE68A',
//   ora:    '#EA580C', oraBg:  '#FFF7ED', oraBdr:  '#FED7AA',
//   sky:    '#0369A1', skyBg:  '#EFF6FF', skyBdr:  '#BAE6FD',
//   grn:    '#15803D', grnBg:  '#F0FDF4', grnBdr:  '#BBF7D0',
//   blue:   '#3B82F6', blueBg: '#EFF6FF', blueBdr: '#BFDBFE',
//   indigo: '#1E40AF',
// };

// /* ─── Known category buckets ─────────────────────────────────────── */
// const CYBER_CATS = [
//   'Advanced Cloud Security', 'Attack Surface Security', 'Domain & DNS',
//   'Domain & DNS Security', 'Identity Threat Intelligence',
//   'Infrastructure & Network Security', 'Network Attack Surface',
//   'TLS Encryption Security', 'TLS/Encryption', 'Web Application Technology',
//   'Security Certifications', 'Cloud Security', 'Network Security',
//   'Web Security', 'Encryption Security', 'Email Security',
//   'Subdomain Security', 'Vulnerability Intelligence', 'DNS Security',
//   'Threat Intelligence', 'Application Security', 'Cubit Score',
//   'Patching Cadence', 'Encryption & SSL', 'Best Practice',
//   'Vulnerability', 'Informational',
// ];
// const OPS_CATS = [
//   'Company Profile', 'Funding & Ownership', 'Reputation & ESG',
//   'Legal & Regulatory', 'Market Intelligence', 'Compliance',
// ];

// const isCyberCat = (cat: string) =>
//   CYBER_CATS.some(c =>
//     cat.toLowerCase().includes(c.toLowerCase()) ||
//     c.toLowerCase().includes(cat.toLowerCase())
//   );
// const isOpsCat = (cat: string) =>
//   OPS_CATS.some(c => cat === c || cat.includes(c));

// const getRiskColor = (level: string) => {
//   const l = level.toLowerCase();
//   if (l === 'critical') return T.red;
//   if (l === 'high')     return '#EA580C';
//   if (l === 'medium')   return T.amb;
//   if (l === 'low')      return T.grn;
//   return T.muted;
// };

// const getScoreBadgeColor = (score: number) => {
//   if (score >= 80) return { bg: '#FEF2F2', text: '#DC2626', bdr: '#FECACA' };
//   if (score >= 60) return { bg: '#FFF7ED', text: '#EA580C', bdr: '#FED7AA' };
//   if (score >= 40) return { bg: '#FFFBEB', text: '#D97706', bdr: '#FDE68A' };
//   return { bg: '#F0FDF4', text: '#16A34A', bdr: '#BBF7D0' };
// };

// const getCatIcon = (cat: string) => {
//   const c = cat.toLowerCase();
//   if (c.includes('encrypt') || c.includes('tls') || c.includes('ssl')) return '🔒';
//   if (c.includes('dns'))      return '🌐';
//   if (c.includes('email'))    return '✉️';
//   if (c.includes('network'))  return '🌐';
//   if (c.includes('web'))      return '🔒';
//   if (c.includes('vuln'))     return '⚠️';
//   if (c.includes('best'))     return '✅';
//   if (c.includes('info'))     return 'ℹ️';
//   if (c.includes('cloud'))    return '☁️';
//   if (c.includes('identity')) return '👤';
//   if (c.includes('compan'))   return '🏢';
//   if (c.includes('legal'))    return '⚖️';
//   if (c.includes('funding'))  return '💰';
//   if (c.includes('market'))   return '📊';
//   if (c.includes('compli'))   return '📋';
//   if (c.includes('reput'))    return '⭐';
//   return '🔍';
// };

// const getSrc = (cat: string) => {
//   const c = cat.toLowerCase();
//   if (c.includes('tls') || c.includes('ssl') || c.includes('encrypt')) return 'SSL Labs API';
//   if (c.includes('dns'))     return 'DNS Analyzer';
//   if (c.includes('email'))   return 'DMARC Analyzer';
//   if (c.includes('network')) return 'Network Scanner';
//   if (c.includes('vuln'))    return 'NVD';
//   return 'Website Analyzer';
// };

// /* ─── Types ──────────────────────────────────────────────────────── */
// interface Indicator {
//   indicator_name: string;
//   category: string;
//   severity: string;
//   score_impact: number;
//   description: string;
//   recommendation: string;
//   evidence?: any;
// }

// interface DomainResult {
//   domain: string;
//   is_primary: boolean;
//   overall_score: number;
//   risk_level: string;
//   category_scores: Record<string, number>;
//   indicators: Indicator[];
//   generated_at?: string;
// }

// interface ScanResult {
//   scan_id: string;
//   company_name: string;
//   primary_domain: string;
//   resolved_ip?: string;
//   all_domains?: string[];
//   domains_scanned?: number;
//   overall_score: number;
//   risk_level: string;
//   category_scores: Record<string, number>;
//   top_risks: any[];
//   indicators: Indicator[];
//   domain_results?: DomainResult[];
//   generated_at: string;
//   completed_at?: string;
//   scan_type?: string;
//   initiated_by?: string;
//   scan_engine?: string;
//   scan_scope?: string;
//   total_ips?: number;
//   total_urls?: number;
//   technologies_detected?: number;
//   exposed_assets?: number;
//   internet_facing?: number;
//   non_internet_facing?: number;
//   assets_at_risk?: number;
//   high_risk_assets?: number;
//   medium_risk_assets?: number;
//   low_risk_assets?: number;
//   vendor_id?: string;
//   vendor_category?: string;
//   vendor_status?: string;
//   initiated_by_name?: string;
//   historical_scores?: { date: string; score: number; critical: number; high: number; medium: number; low: number }[];
// }

// const mono = "'JetBrains Mono', monospace";
// const sans = "'Inter', system-ui, sans-serif";

// /* ─── Circular gauge ─────────────────────────────────────────────── */
// const RiskGauge = ({ score, riskLevel, isDark }: { score: number; riskLevel: string; isDark?: boolean }) => {
//   const color = getRiskColor(riskLevel);
//   const r = 28;
//   const circ = 2 * Math.PI * r;
//   const dash = (score / 100) * circ;
//   return (
//     <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
//       <div style={{ position: 'relative', width: 72, height: 72, flexShrink: 0 }}>
//         <svg width="72" height="72" viewBox="0 0 72 72">
//           <circle cx="36" cy="36" r={r} fill="none" stroke={isDark ? '#1f1f1f' : '#E2E8F0'} strokeWidth="6" />
//           <circle cx="36" cy="36" r={r} fill="none" stroke={color} strokeWidth="6"
//             strokeDasharray={`${dash} ${circ - dash}`}
//             strokeDashoffset={circ * 0.25}
//             strokeLinecap="round"
//             style={{ transition: 'stroke-dasharray 0.6s ease' }}
//           />
//           <text x="36" y="39" textAnchor="middle" fontSize="14" fontWeight="700"
//             fill={color} fontFamily={sans}>{score}</text>
//         </svg>
//       </div>
//       <div>
//         <div style={{ fontSize: 11, color: isDark ? '#94a3b8' : T.muted, marginBottom: 2 }}>Overall Risk Score</div>
//         <div style={{ fontSize: 16, fontWeight: 700, color, marginBottom: 2 }}>{riskLevel} Risk</div>
//         <div style={{ fontSize: 11, color: isDark ? '#94a3b8' : T.muted }}>Score increased by 8<br />from last scan</div>
//       </div>
//     </div>
//   );
// };

// /* ─── Status chip ────────────────────────────────────────────────── */
// const StatusChip = ({ status, isDark }: { status: string; isDark?: boolean }) => (
//   <span style={{
//     display: 'inline-flex', alignItems: 'center', gap: 4,
//     padding: '3px 10px', borderRadius: 20,
//     background: isDark ? '#0a1a0a' : '#F0FDF4',
//     border: `1px solid ${isDark ? '#15803D40' : '#BBF7D0'}`,
//     fontSize: 11, fontWeight: 600, color: '#16A34A',
//   }}>
//     <span style={{ width: 5, height: 5, borderRadius: '50%', background: '#16A34A' }} />
//     {status}
//   </span>
// );

// /* ─── Indicator ID sub-label ─────────────────────────────────────── */
// const IndId = ({ name, idx, isDark }: { name: string; idx: number; isDark?: boolean }) => {
//   const prefix = name.toLowerCase().includes('vuln') ? 'VULN'
//     : name.toLowerCase().includes('sec') ? 'SEC'
//     : 'INFO';
//   return (
//     <div style={{ fontSize: 10, color: isDark ? '#6b7280' : T.muted, marginTop: 2, fontFamily: mono }}>
//       {`IND-${prefix}-${String(idx + 1000).padStart(6, '0')}`}
//     </div>
//   );
// };

// /* ─── Checkbox (filter sidebar only) ────────────────────────────── */
// const FCheck = ({ checked, onChange, isDark }: { checked: boolean; onChange: () => void; isDark?: boolean }) => (
//   <div
//     onClick={e => { e.stopPropagation(); onChange(); }}
//     style={{
//       width: 15, height: 15, borderRadius: 3, flexShrink: 0, cursor: 'pointer',
//       border: `2px solid ${checked ? T.blue : (isDark ? '#1f1f1f' : T.bdr2)}`,
//       background: checked ? T.blue : (isDark ? '#0d0d0d' : T.surface),
//       display: 'flex', alignItems: 'center', justifyContent: 'center',
//       transition: 'all .15s',
//     }}>
//     {checked && (
//       <svg width="9" height="9" viewBox="0 0 12 12">
//         <polyline points="2,6 5,9 10,3" stroke="#fff" strokeWidth="2.2"
//           fill="none" strokeLinecap="round" strokeLinejoin="round" />
//       </svg>
//     )}
//   </div>
// );

// /* ─── Main ───────────────────────────────────────────────────────── */
// export default function ScanResults() {
//   const { scanId } = useParams();
//   const navigate   = useNavigate();

//   // ─── Theme Colors ──────────────────────────────────────────────────────────
//   const { mode } = useCustomTheme();
//   const isDark = mode === 'dark';

//   const themeColors = {
//     text: isDark ? '#e2e8f0' : '#0F172A',
//     muted: isDark ? '#94a3b8' : '#64748B',
//     background: isDark ? '#000000' : '#F8FAFC',
//     cardBg: isDark ? '#0d0d0d' : '#FFFFFF',
//     border: isDark ? '#1f1f1f' : '#E2E8F0',
//     hover: isDark ? '#141414' : '#F8FAFC',
//     paper: isDark ? '#0d0d0d' : '#FFFFFF',
//     surface: isDark ? '#0d0d0d' : '#FFFFFF',
//     surface2: isDark ? '#1a1a1a' : '#F8FAFC',
//   };

//   const [result,         setResult]         = useState<ScanResult | null>(null);
//   const [loading,        setLoading]        = useState(true);
//   const [error,          setError]          = useState<string | null>(null);
//   const [domainResults,  setDomainResults]  = useState<DomainResult[]>([]);
//   const [selectedDomain, setSelectedDomain] = useState('');

//   /* ── Filter state ── */
//   const [sevFilter,     setSevFilter]     = useState<string[]>([]);
//   const [catFilter,     setCatFilter]     = useState<Set<string>>(new Set());
//   const [search,        setSearch]        = useState('');

//   /* ── Category group expand state ── */
//   const [cyberExpanded, setCyberExpanded] = useState(false);
//   const [opsExpanded,   setOpsExpanded]   = useState(false);

//   /* ── Pagination ── */
//   const [page,    setPage]    = useState(1);
//   const [perPage, setPerPage] = useState(10);

//   /* ── UI state ── */
//   const [modalOpen,      setModalOpen]      = useState(false);
//   const [selInd,         setSelInd]         = useState<Indicator | null>(null);
//   const [showColMenu,    setShowColMenu]     = useState(false);
//   const [showFilterPane, setShowFilterPane] = useState(true);
//   const [cols, setCols] = useState({
//     riskScore: true, indicator: true, category: true, source: true,
//     firstDetected: true, lastDetected: true, status: true,
//   });

//   useEffect(() => { if (scanId) fetchResults(); }, [scanId]);

//   const fetchVendorIdFromDomain = async (domain: string) => {
//     try {
//       const { data } = await api.get(`/v1/vendors/by-domain/${domain}`);
//       if (data && data.id) {
//         setResult(prev => prev ? { ...prev, vendor_id: data.id } : prev);
//         console.log('✅ Fetched vendor ID:', data.id, 'for domain:', domain);
//       }
//     } catch (e) {
//       console.log('Could not fetch vendor ID for domain:', domain, e);
//     }
//   };

//   const fetchResults = async () => {
//     setLoading(true);
//     try {
//       const { data } = await api.get(`/v1/scan/${scanId}`);
//       if (data.status === 'processing') {
//         setError('Scan in progress — redirecting…');
//         setTimeout(() => navigate(`/scans/${scanId}/progress`), 2000);
//         setLoading(false);
//         return;
//       }
//       let domains: DomainResult[] = data.domain_results || [];
//       if (!domains.length && data.indicators) {
//         domains = [{
//           domain: data.primary_domain || data.domain,
//           is_primary: true,
//           overall_score: data.overall_score,
//           risk_level: data.risk_level,
//           category_scores: data.category_scores || {},
//           indicators: data.indicators || [],
//           generated_at: data.generated_at,
//         }];
//       }
//       setDomainResults(domains);
//       const primary = domains.find(d => d.is_primary) || domains[0];
//       if (primary) setSelectedDomain(primary.domain);
//       setResult({
//         scan_id: data.scan_id,
//         company_name: data.company_name,
//         primary_domain: data.primary_domain || data.domain,
//         resolved_ip: data.resolved_ip,
//         all_domains: data.all_domains || domains.map(d => d.domain),
//         domains_scanned: data.domains_scanned || domains.length,
//         overall_score: data.overall_score,
//         risk_level: data.risk_level,
//         category_scores: data.category_scores || {},
//         top_risks: data.top_risks || [],
//         indicators: data.indicators || [],
//         domain_results: domains,
//         generated_at: data.generated_at,
//         completed_at: data.completed_at,
//         scan_type: data.scan_type || 'Full Scan',
//         scan_engine: data.scan_engine,
//         scan_scope: data.scan_scope,
//         total_ips: data.total_ips,
//         total_urls: data.total_urls,
//         technologies_detected: data.technologies_detected,
//         exposed_assets: data.exposed_assets,
//         internet_facing: data.internet_facing,
//         non_internet_facing: data.non_internet_facing,
//         assets_at_risk: data.assets_at_risk,
//         high_risk_assets: data.high_risk_assets,
//         medium_risk_assets: data.medium_risk_assets,
//         low_risk_assets: data.low_risk_assets,
//         vendor_id: data.vendor_id,
//         vendor_category: data.vendor_category,
//         vendor_status: data.vendor_status || 'Active',
//         initiated_by_name: data.initiated_by_name || data.initiated_by,
//         historical_scores: data.historical_scores || [],
//       });

//       const primaryDomain = data.primary_domain || data.domain;
//       if (primaryDomain && !data.vendor_id) {
//         await fetchVendorIdFromDomain(primaryDomain);
//       }

//     } catch (e: any) {
//       setError(e.response?.status === 404 ? 'Scan not found.' : 'Failed to load results.');
//     } finally { setLoading(false); }
//   };

//   const domainData = domainResults.find(d => d.domain === selectedDomain) || domainResults[0];
//   const indicators = domainData?.indicators || [];
//   const score      = domainData?.overall_score || 0;
//   const riskLevel  = domainData?.risk_level    || 'Unknown';

//   const sevCounts = useMemo(() => {
//     const c = { Critical: 0, High: 0, Medium: 0, Low: 0, Info: 0 };
//     indicators.forEach(i => { if (i.severity in c) (c as any)[i.severity]++; });
//     return c;
//   }, [indicators]);

//   const totalFindings = Object.values(sevCounts).reduce((s, v) => s + v, 0);

//   const allCats     = useMemo(() => Array.from(new Set(indicators.map(i => i.category))).sort(), [indicators]);
//   const cyberCats   = useMemo(() => allCats.filter(isCyberCat), [allCats]);
//   const opsCats     = useMemo(() => allCats.filter(isOpsCat),   [allCats]);
//   const uncatCats   = useMemo(() => allCats.filter(c => !isCyberCat(c) && !isOpsCat(c)), [allCats]);

//   const catCount = useMemo(() => {
//     const m: Record<string, number> = {};
//     indicators.forEach(i => { m[i.category] = (m[i.category] || 0) + 1; });
//     return m;
//   }, [indicators]);

//   const cyberTotal = useMemo(() => cyberCats.reduce((s, c) => s + (catCount[c] || 0), 0), [cyberCats, catCount]);
//   const opsTotal   = useMemo(() => opsCats.reduce((s, c)   => s + (catCount[c] || 0), 0), [opsCats, catCount]);

//   const toDisplayScore = (ind: Indicator) => {
//     const abs = Math.abs(ind.score_impact);
//     if (abs >= 20) return 80 + Math.min(abs - 20, 20);
//     if (abs >= 10) return 60 + (abs - 10) * 2;
//     if (abs >= 5)  return 40 + (abs - 5) * 4;
//     return Math.max(10, abs * 8);
//   };

//   const filteredInds = useMemo(() => {
//     const s = search.toLowerCase();
//     return indicators.filter(i =>
//       (!s || i.indicator_name.toLowerCase().includes(s) ||
//              i.description.toLowerCase().includes(s) ||
//              i.category.toLowerCase().includes(s)) &&
//       (sevFilter.length === 0 || sevFilter.includes(i.severity)) &&
//       (catFilter.size === 0 || catFilter.has(i.category))
//     );
//   }, [indicators, search, sevFilter, catFilter]);

//   const totalPages = Math.max(1, Math.ceil(filteredInds.length / perPage));
//   const pageItems  = filteredInds.slice((page - 1) * perPage, page * perPage);

//   const openModal  = (ind: Indicator) => { setSelInd(ind); setModalOpen(true); };
//   const closeModal = () => { setModalOpen(false); setSelInd(null); };

//   const toggleSev = (sev: string) => {
//     setSevFilter(prev => prev.includes(sev) ? prev.filter(s => s !== sev) : [...prev, sev]);
//     setPage(1);
//   };
//   const toggleHighGroup = () => {
//     const hasCrit = sevFilter.includes('Critical');
//     const hasHigh = sevFilter.includes('High');
//     if (hasCrit || hasHigh) setSevFilter(prev => prev.filter(s => s !== 'Critical' && s !== 'High'));
//     else setSevFilter(prev => [...prev.filter(s => s !== 'Critical' && s !== 'High'), 'Critical', 'High']);
//     setPage(1);
//   };

//   const toggleCat = (cat: string) => {
//     setCatFilter(prev => {
//       const next = new Set(prev);
//       if (next.has(cat)) next.delete(cat); else next.add(cat);
//       return next;
//     });
//     setPage(1);
//   };

//   const toggleGroup = (group: string[]) => {
//     const allSelected = group.every(c => catFilter.has(c));
//     setCatFilter(prev => {
//       const next = new Set(prev);
//       if (allSelected) group.forEach(c => next.delete(c));
//       else group.forEach(c => next.add(c));
//       return next;
//     });
//     setPage(1);
//   };

//   const clearFilters = () => {
//     setSevFilter([]); setCatFilter(new Set()); setSearch(''); setPage(1);
//   };

//   const fmtDateShort = (iso: string) => {
//     const d = new Date(iso);
//     return {
//       date: d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }),
//       time: d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' }),
//     };
//   };

//   const activeFilterCount =
//     sevFilter.length +
//     (catFilter.size > 0 ? 1 : 0) +
//     (search ? 1 : 0);

//   /* ── Loading ── */
//   if (loading) return (
//     <div style={{ fontFamily: sans, background: isDark ? '#000000' : T.bg, minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 12 }}>
//       <style>{`@keyframes slide{from{transform:translateX(-40px)}to{transform:translateX(80px)}}`}</style>
//       <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={T.blue} strokeWidth="1.5">
//         <path d="M10 2L3 5v5c0 4.1 3 7.9 7 9 4-1.1 7-4.9 7-9V5L10 2z"/>
//         <path d="M7 12l2 2 5-5" strokeLinecap="round" strokeLinejoin="round"/>
//       </svg>
//       <span style={{ fontFamily: mono, fontSize: 11, color: isDark ? '#94a3b8' : T.slate, letterSpacing: '.12em' }}>LOADING REPORT…</span>
//       <div style={{ width: 160, height: 2, background: isDark ? '#1f1f1f' : T.bdr, borderRadius: 2, overflow: 'hidden' }}>
//         <div style={{ width: '60%', height: 2, background: T.blue, borderRadius: 2, animation: 'slide 1.2s ease-in-out infinite alternate' }} />
//       </div>
//     </div>
//   );

//   if (error || !result) return (
//     <div style={{ fontFamily: sans, background: isDark ? '#000000' : T.bg, minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//       <div style={{ textAlign: 'center', maxWidth: 360 }}>
//         <div style={{ fontSize: 13, color: T.red, marginBottom: 12, padding: '10px 16px', background: isDark ? '#1a0a0a' : T.redBg, border: `1px solid ${isDark ? '#DC262640' : T.redBdr}`, borderRadius: 4 }}>
//           {error || 'Scan results not found.'}
//         </div>
//         <button onClick={() => navigate('/scans/new')} style={{ background: isDark ? '#3B82F6' : T.ink, border: `1px solid ${isDark ? '#3B82F6' : T.ink}`, color: '#fff', fontSize: 12, fontWeight: 600, padding: '8px 20px', borderRadius: 3, cursor: 'pointer', fontFamily: sans }}>
//           Start New Scan
//         </button>
//       </div>
//     </div>
//   );

//   const completedAt = result.completed_at || result.generated_at;
//   const { date: cDate, time: cTime } = fmtDateShort(completedAt);
//   const effectiveVendorId = result.vendor_id;

//   /* ─────────────────── RENDER ─────────────────────────────────── */
//   return (
//     <div style={{ fontFamily: sans, background: isDark ? '#000000' : T.bg, minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
//       <IndicatorDetailModal 
//         open={modalOpen} 
//         onClose={closeModal} 
//         indicator={selInd as any}
//         vendorName={result?.company_name}
//         domain={selectedDomain}
//         vendorIp={result?.resolved_ip}
//         vendorId={effectiveVendorId}
//         scanId={scanId}
        
//       />

//       {/* ── Topbar ─────────────────────────────────────────────── */}
//       <div style={{ background: isDark ? '#0d0d0d' : '#1A1D2E', height: 44, display: 'flex', alignItems: 'center', padding: '0 18px', gap: 10, flexShrink: 0, position: 'sticky', top: 0, zIndex: 200 }}>
//         <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
//           <path d="M10 2L3 5v5c0 4.1 3 7.9 7 9 4-1.1 7-4.9 7-9V5L10 2z" stroke="#4A9EFF" strokeWidth="1.5" strokeLinejoin="round"/>
//           <path d="M7 10l2 2 4-4" stroke="#4A9EFF" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
//         </svg>
//         <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.16em', color: '#4A9EFF', textTransform: 'uppercase' }}>Vendor Risk</span>
//         <div style={{ width: 1, height: 16, background: 'rgba(255,255,255,.12)', margin: '0 2px' }} />
//         <img
//           src={`https://www.google.com/s2/favicons?domain=${result.primary_domain}&sz=16`}
//           alt="" style={{ width: 16, height: 16, borderRadius: 2 }}
//           onError={e => { (e.target as HTMLImageElement).style.display = 'none'; }}
//         />
//         <span style={{ fontSize: 12, color: 'rgba(255,255,255,.4)' }}>{result.company_name} — {result.primary_domain}</span>
//         <div style={{ flex: 1 }} />
//         <div style={{ display: 'flex', gap: 6 }}>
//           <button
//             style={{ background: 'rgba(255,255,255,.07)', border: '1px solid rgba(255,255,255,.12)', color: 'rgba(255,255,255,.7)', fontSize: 11, fontWeight: 600, padding: '5px 14px', borderRadius: 6, cursor: 'pointer', fontFamily: sans, display: 'flex', alignItems: 'center', gap: 5 }}
//             onClick={() => {
//               const blob = new Blob([JSON.stringify({ ...result, domain_results: domainResults }, null, 2)], { type: 'application/json' });
//               const a = document.createElement('a'); a.href = URL.createObjectURL(blob);
//               a.download = `${result.company_name}_scan.json`; a.click();
//             }}>
//             <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//               <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/>
//               <polyline points="7 10 12 15 17 10"/>
//               <line x1="12" y1="15" x2="12" y2="3"/>
//             </svg>
//             Export Report
//           </button>
//           <button
//             style={{ background: 'rgba(255,255,255,.07)', border: '1px solid rgba(255,255,255,.12)', color: 'rgba(255,255,255,.7)', fontSize: 11, fontWeight: 600, padding: '5px 14px', borderRadius: 6, cursor: 'pointer', fontFamily: sans }}
//             onClick={() => navigate(`/scans/${scanId}/progress`)}>
//             ⟳ Rescan
//           </button>
//           <button
//             onClick={() => navigate('/scans/new')}
//             style={{ background: T.blue, border: 'none', color: '#fff', fontSize: 11, fontWeight: 600, padding: '5px 14px', borderRadius: 6, cursor: 'pointer', fontFamily: sans }}>
//             + New Scan
//           </button>
//         </div>
//       </div>

//       {/* ── Breadcrumb ─────────────────────────────────────────── */}
//       <div style={{ background: isDark ? '#0d0d0d' : T.surface, borderBottom: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`, padding: '0 20px', height: 38, display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, flexShrink: 0 }}>
//         <span style={{ color: isDark ? '#3B82F6' : T.blue, fontWeight: 500, cursor: 'pointer' }} onClick={() => navigate('/vendors')}>Third Parties</span>
//         <span style={{ color: isDark ? '#6b7280' : T.faint }}>/</span>
//         <span style={{ color: isDark ? '#3B82F6' : T.blue, fontWeight: 500, cursor: 'pointer' }} onClick={() => navigate('/vendors')}>Vendors</span>
//         <span style={{ color: isDark ? '#6b7280' : T.faint }}>/</span>
//         <span style={{ color: isDark ? '#94a3b8' : T.slate, fontWeight: 500 }}>{result.company_name}</span>
//         <span style={{ color: isDark ? '#6b7280' : T.faint }}>/</span>
//         <span style={{ color: isDark ? '#e2e8f0' : T.ink, fontWeight: 600 }}>Scan Results</span>
//       </div>

//       {/* ── Page header ────────────────────────────────────────── */}
//       <div style={{ background: isDark ? '#0d0d0d' : T.surface, borderBottom: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`, padding: '16px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
//         <div>
//           <div style={{ fontSize: 22, fontWeight: 700, color: isDark ? '#e2e8f0' : T.ink }}>Scan Results</div>
//           <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginTop: 6 }}>
//             <StatusChip status="Completed" isDark={isDark} />
//             <span style={{ fontSize: 12, color: isDark ? '#94a3b8' : T.slate }}>{cDate}, {cTime}</span>
//             <span style={{ color: isDark ? '#6b7280' : T.faint }}>•</span>
//             <span style={{ fontSize: 12, color: isDark ? '#94a3b8' : T.slate }}>{result.scan_type || 'Full Scan'}</span>
//             <span style={{ color: isDark ? '#6b7280' : T.faint }}>•</span>
//             <span style={{ fontSize: 12, color: isDark ? '#94a3b8' : T.slate }}>Scan ID: {result.scan_id}</span>
//           </div>
//         </div>
//         <button style={{ background: isDark ? '#0d0d0d' : T.surface, border: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`, color: isDark ? '#94a3b8' : T.slate, fontSize: 16, padding: '5px 14px', borderRadius: 6, cursor: 'pointer', lineHeight: 1 }}>
//           •••
//         </button>
//       </div>

//       {/* ── Summary cards ──────────────────────────────────────── */}
//       <div style={{ background: isDark ? '#0d0d0d' : T.surface, borderBottom: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`, padding: '16px 20px', flexShrink: 0 }}>
//         <div style={{ display: 'grid', gridTemplateColumns: 'auto 1fr 1fr 1fr 1fr 1fr', gap: 12 }}>

//           {/* Gauge */}
//           <div style={{ background: isDark ? '#0d0d0d' : T.surface, border: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`, borderRadius: 8, padding: '16px 20px', display: 'flex', alignItems: 'center' }}>
//             <RiskGauge score={score} riskLevel={riskLevel} isDark={isDark} />
//           </div>

//           {/* Total Indicators */}
//           <div style={{ background: isDark ? '#0d0d0d' : T.surface, border: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`, borderRadius: 8, padding: '16px 20px' }}>
//             <div style={{ fontSize: 12, color: isDark ? '#94a3b8' : T.muted, marginBottom: 8, fontWeight: 500 }}>Total Indicators</div>
//             <div style={{ fontSize: 28, fontWeight: 700, color: isDark ? '#e2e8f0' : T.ink, lineHeight: 1, marginBottom: 6 }}>{totalFindings.toLocaleString()}</div>
//             <div style={{ fontSize: 11 }}>
//               <span style={{ color: '#16A34A' }}>↑ 5%</span>
//               <span style={{ color: isDark ? '#94a3b8' : T.muted }}> from last scan</span>
//             </div>
//           </div>

//           {/* High Risk */}
//           <div style={{ background: isDark ? '#0d0d0d' : T.surface, border: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`, borderRadius: 8, padding: '16px 20px' }}>
//             <div style={{ fontSize: 12, color: isDark ? '#94a3b8' : T.muted, marginBottom: 8, fontWeight: 500 }}>High Risk</div>
//             <div style={{ fontSize: 28, fontWeight: 700, color: '#EA580C', lineHeight: 1, marginBottom: 6 }}>{(sevCounts.Critical + sevCounts.High).toLocaleString()}</div>
//             <div style={{ fontSize: 11 }}>
//               <span style={{ color: '#EA580C' }}>↑ 12%</span>
//               <span style={{ color: isDark ? '#94a3b8' : T.muted }}> from last scan</span>
//             </div>
//           </div>

//           {/* Medium Risk */}
//           <div style={{ background: isDark ? '#0d0d0d' : T.surface, border: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`, borderRadius: 8, padding: '16px 20px' }}>
//             <div style={{ fontSize: 12, color: isDark ? '#94a3b8' : T.muted, marginBottom: 8, fontWeight: 500 }}>Medium Risk</div>
//             <div style={{ fontSize: 28, fontWeight: 700, color: '#D97706', lineHeight: 1, marginBottom: 6 }}>{sevCounts.Medium.toLocaleString()}</div>
//             <div style={{ fontSize: 11 }}>
//               <span style={{ color: '#16A34A' }}>↓ 3%</span>
//               <span style={{ color: isDark ? '#94a3b8' : T.muted }}> from last scan</span>
//             </div>
//           </div>

//           {/* Low Risk */}
//           <div style={{ background: isDark ? '#0d0d0d' : T.surface, border: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`, borderRadius: 8, padding: '16px 20px' }}>
//             <div style={{ fontSize: 12, color: isDark ? '#94a3b8' : T.muted, marginBottom: 8, fontWeight: 500 }}>Low Risk</div>
//             <div style={{ fontSize: 28, fontWeight: 700, color: '#16A34A', lineHeight: 1, marginBottom: 6 }}>{sevCounts.Low.toLocaleString()}</div>
//             <div style={{ fontSize: 11 }}>
//               <span style={{ color: '#16A34A' }}>↓ 8%</span>
//               <span style={{ color: isDark ? '#94a3b8' : T.muted }}> from last scan</span>
//             </div>
//           </div>

//           {/* Informational */}
//           <div style={{ background: isDark ? '#0d0d0d' : T.surface, border: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`, borderRadius: 8, padding: '16px 20px' }}>
//             <div style={{ fontSize: 12, color: isDark ? '#94a3b8' : T.muted, marginBottom: 8, fontWeight: 500 }}>Informational</div>
//             <div style={{ fontSize: 28, fontWeight: 700, color: isDark ? '#e2e8f0' : T.ink, lineHeight: 1, marginBottom: 6 }}>{sevCounts.Info.toLocaleString()}</div>
//             <div style={{ fontSize: 11, color: isDark ? '#94a3b8' : T.muted }}>No change</div>
//           </div>
//         </div>
//       </div>

//       {/* ── Domain tabs (multi-domain) ──────────────────────────── */}
//       {domainResults.length > 1 && (
//         <div style={{ background: isDark ? '#0d0d0d' : T.surface, borderBottom: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`, padding: '0 20px', display: 'flex', gap: 6, alignItems: 'center', height: 44, flexShrink: 0 }}>
//           <span style={{ fontSize: 11, color: isDark ? '#94a3b8' : T.muted, fontWeight: 600, letterSpacing: '.07em', textTransform: 'uppercase', marginRight: 6 }}>Domain:</span>
//           {domainResults.map(dr => (
//             <button key={dr.domain} onClick={() => setSelectedDomain(dr.domain)} style={{
//               display: 'flex', alignItems: 'center', gap: 6,
//               background: selectedDomain === dr.domain ? (isDark ? '#e2e8f0' : T.ink) : (isDark ? '#1a1a1a' : T.surface2),
//               border: `1px solid ${selectedDomain === dr.domain ? (isDark ? '#e2e8f0' : T.ink) : (isDark ? '#1f1f1f' : T.bdr)}`,
//               borderRadius: 6, padding: '4px 12px', fontSize: 12, cursor: 'pointer',
//               color: selectedDomain === dr.domain ? (isDark ? '#0d0d0d' : '#fff') : (isDark ? '#94a3b8' : T.slate),
//               fontFamily: sans,
//             }}>
//               {dr.domain}
//               {dr.is_primary && (
//                 <span style={{ background: T.blue, color: '#fff', fontSize: 9, fontWeight: 700, padding: '1px 5px', borderRadius: 3 }}>
//                   PRIMARY
//                 </span>
//               )}
//             </button>
//           ))}
//         </div>
//       )}

//       {/* ── Body: sidebar + table ──────────────────────────────── */}
//       <div style={{ flex: 1, display: 'flex', overflow: 'hidden' }}>

//         {/* ─────────── LEFT SIDEBAR ─────────────────────────────── */}
//         {showFilterPane && (
//           <div style={{
//             width: 232, flexShrink: 0,
//             background: isDark ? '#0d0d0d' : T.surface,
//             borderRight: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`,
//             overflowY: 'auto', padding: '20px 16px',
//           }}>
//             {/* Header */}
//             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
//               <span style={{ fontSize: 14, fontWeight: 600, color: isDark ? '#e2e8f0' : T.ink }}>Filters</span>
//               <button onClick={clearFilters}
//                 style={{ fontSize: 12, color: isDark ? '#3B82F6' : T.blue, background: 'none', border: 'none', cursor: 'pointer', fontFamily: sans, fontWeight: 500, padding: 0 }}>
//                 Clear All
//               </button>
//             </div>

//             {/* ── RISK LEVEL ── */}
//             <div style={{ marginBottom: 20 }}>
//               <div style={{ fontSize: 11, fontWeight: 700, color: isDark ? '#e2e8f0' : T.ink, marginBottom: 12, textTransform: 'uppercase', letterSpacing: '.07em' }}>
//                 Risk Level
//               </div>

//               <div style={{ display: 'flex', alignItems: 'center', gap: 9, marginBottom: 10, cursor: 'pointer' }}
//                 onClick={toggleHighGroup}>
//                 <FCheck checked={sevFilter.includes('Critical') || sevFilter.includes('High')} onChange={toggleHighGroup} isDark={isDark} />
//                 <span style={{ fontSize: 13, color: isDark ? '#e2e8f0' : T.ink, flex: 1, userSelect: 'none' }}>High</span>
//                 <span style={{ fontSize: 12, fontWeight: 600, color: '#EA580C' }}>{sevCounts.Critical + sevCounts.High}</span>
//               </div>

//               <div style={{ display: 'flex', alignItems: 'center', gap: 9, marginBottom: 10, cursor: 'pointer' }}
//                 onClick={() => toggleSev('Medium')}>
//                 <FCheck checked={sevFilter.includes('Medium')} onChange={() => toggleSev('Medium')} isDark={isDark} />
//                 <span style={{ fontSize: 13, color: isDark ? '#e2e8f0' : T.ink, flex: 1, userSelect: 'none' }}>Medium</span>
//                 <span style={{ fontSize: 12, fontWeight: 600, color: '#D97706' }}>{sevCounts.Medium}</span>
//               </div>

//               <div style={{ display: 'flex', alignItems: 'center', gap: 9, marginBottom: 10, cursor: 'pointer' }}
//                 onClick={() => toggleSev('Low')}>
//                 <FCheck checked={sevFilter.includes('Low')} onChange={() => toggleSev('Low')} isDark={isDark} />
//                 <span style={{ fontSize: 13, color: isDark ? '#e2e8f0' : T.ink, flex: 1, userSelect: 'none' }}>Low</span>
//                 <span style={{ fontSize: 12, fontWeight: 600, color: '#16A34A' }}>{sevCounts.Low}</span>
//               </div>

//               <div style={{ display: 'flex', alignItems: 'center', gap: 9, cursor: 'pointer' }}
//                 onClick={() => toggleSev('Info')}>
//                 <FCheck checked={sevFilter.includes('Info')} onChange={() => toggleSev('Info')} isDark={isDark} />
//                 <span style={{ fontSize: 13, color: isDark ? '#e2e8f0' : T.ink, flex: 1, userSelect: 'none' }}>Informational</span>
//                 <span style={{ fontSize: 12, fontWeight: 600, color: isDark ? '#94a3b8' : T.slate }}>{sevCounts.Info}</span>
//               </div>
//             </div>

//             <div style={{ height: 1, background: isDark ? '#1f1f1f' : T.bdr, marginBottom: 20 }} />

//             {/* ── CATEGORY ── */}
//             <div>
//               <div style={{ fontSize: 11, fontWeight: 700, color: isDark ? '#e2e8f0' : T.ink, marginBottom: 12, textTransform: 'uppercase', letterSpacing: '.07em' }}>
//                 Category
//               </div>

//               {cyberCats.length > 0 && (
//                 <div style={{ marginBottom: 6 }}>
//                   <div
//                     style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '5px 0', cursor: 'pointer', borderRadius: 4 }}
//                     onClick={() => setCyberExpanded(v => !v)}>
//                     <span style={{ fontSize: 10, color: isDark ? '#94a3b8' : T.muted, width: 12, textAlign: 'center', flexShrink: 0, transition: 'transform .15s', display: 'inline-block', transform: cyberExpanded ? 'rotate(90deg)' : 'rotate(0deg)' }}>
//                       ▶
//                     </span>
//                     <FCheck
//                       checked={cyberCats.length > 0 && cyberCats.every(c => catFilter.has(c))}
//                       onChange={() => toggleGroup(cyberCats)}
//                       isDark={isDark}
//                     />
//                     <span style={{ fontSize: 13, fontWeight: 600, color: isDark ? '#e2e8f0' : T.ink, flex: 1, userSelect: 'none' }}>Cybersecurity</span>
//                     <span style={{ fontSize: 11, color: isDark ? '#94a3b8' : T.muted, fontFamily: mono }}>{cyberTotal}</span>
//                   </div>

//                   {cyberExpanded && (
//                     <div style={{ marginLeft: 20, marginTop: 2 }}>
//                       {cyberCats.map(cat => (
//                         <div
//                           key={cat}
//                           style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '4px 0', cursor: 'pointer' }}
//                           onClick={() => toggleCat(cat)}>
//                           <FCheck checked={catFilter.has(cat)} onChange={() => toggleCat(cat)} isDark={isDark} />
//                           <span style={{ fontSize: 12, color: isDark ? '#94a3b8' : T.slate, flex: 1, userSelect: 'none', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={cat}>
//                             {cat}
//                           </span>
//                           <span style={{ fontSize: 11, color: isDark ? '#94a3b8' : T.muted, fontFamily: mono, flexShrink: 0 }}>{catCount[cat] || 0}</span>
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               )}

//               {opsCats.length > 0 && (
//                 <div style={{ marginBottom: 6 }}>
//                   <div
//                     style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '5px 0', cursor: 'pointer', borderRadius: 4 }}
//                     onClick={() => setOpsExpanded(v => !v)}>
//                     <span style={{ fontSize: 10, color: isDark ? '#94a3b8' : T.muted, width: 12, textAlign: 'center', flexShrink: 0, transition: 'transform .15s', display: 'inline-block', transform: opsExpanded ? 'rotate(90deg)' : 'rotate(0deg)' }}>
//                       ▶
//                     </span>
//                     <FCheck
//                       checked={opsCats.length > 0 && opsCats.every(c => catFilter.has(c))}
//                       onChange={() => toggleGroup(opsCats)}
//                       isDark={isDark}
//                     />
//                     <span style={{ fontSize: 13, fontWeight: 600, color: isDark ? '#e2e8f0' : T.ink, flex: 1, userSelect: 'none' }}>Operational</span>
//                     <span style={{ fontSize: 11, color: isDark ? '#94a3b8' : T.muted, fontFamily: mono }}>{opsTotal}</span>
//                   </div>

//                   {opsExpanded && (
//                     <div style={{ marginLeft: 20, marginTop: 2 }}>
//                       {opsCats.map(cat => (
//                         <div
//                           key={cat}
//                           style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '4px 0', cursor: 'pointer' }}
//                           onClick={() => toggleCat(cat)}>
//                           <FCheck checked={catFilter.has(cat)} onChange={() => toggleCat(cat)} isDark={isDark} />
//                           <span style={{ fontSize: 12, color: isDark ? '#94a3b8' : T.slate, flex: 1, userSelect: 'none', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={cat}>
//                             {cat}
//                           </span>
//                           <span style={{ fontSize: 11, color: isDark ? '#94a3b8' : T.muted, fontFamily: mono, flexShrink: 0 }}>{catCount[cat] || 0}</span>
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               )}

//               {uncatCats.length > 0 && uncatCats.map(cat => (
//                 <div
//                   key={cat}
//                   style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '4px 0', marginLeft: 20, cursor: 'pointer' }}
//                   onClick={() => toggleCat(cat)}>
//                   <FCheck checked={catFilter.has(cat)} onChange={() => toggleCat(cat)} isDark={isDark} />
//                   <span style={{ fontSize: 12, color: isDark ? '#94a3b8' : T.slate, flex: 1, userSelect: 'none', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={cat}>
//                     {cat}
//                   </span>
//                   <span style={{ fontSize: 11, color: isDark ? '#94a3b8' : T.muted, fontFamily: mono, flexShrink: 0 }}>{catCount[cat] || 0}</span>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         {/* ─────────── RIGHT: toolbar + table + pagination ──────── */}
//         <div style={{ flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column', minWidth: 0 }}>

//           {/* Toolbar */}
//           <div style={{
//             background: isDark ? '#0d0d0d' : T.surface,
//             borderBottom: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`,
//             padding: '10px 20px', display: 'flex', alignItems: 'center', gap: 10,
//             flexShrink: 0, position: 'sticky', top: 0, zIndex: 10,
//           }}>
//             <button
//               onClick={() => setShowFilterPane(v => !v)}
//               style={{
//                 background: showFilterPane ? (isDark ? '#0a1628' : T.blueBg) : (isDark ? '#0d0d0d' : T.surface),
//                 border: `1px solid ${showFilterPane ? (isDark ? '#3B82F6' : T.blue) : (isDark ? '#1f1f1f' : T.bdr)}`,
//                 color: showFilterPane ? (isDark ? '#3B82F6' : T.blue) : (isDark ? '#94a3b8' : T.slate),
//                 fontSize: 12, fontWeight: 500, padding: '6px 12px', borderRadius: 6,
//                 cursor: 'pointer', fontFamily: sans, display: 'flex', alignItems: 'center', gap: 5,
//               }}>
//               <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                 <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>
//               </svg>
//               Filters
//             </button>

//             <span style={{ fontSize: 13, fontWeight: 600, color: isDark ? '#e2e8f0' : T.ink }}>
//               {filteredInds.length.toLocaleString()} results
//             </span>

//             <div style={{ flex: 1 }} />

//             <div style={{ position: 'relative' }}>
//               <svg style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', pointerEvents: 'none' }}
//                 width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={isDark ? '#94a3b8' : T.muted} strokeWidth="2">
//                 <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
//               </svg>
//               <input
//                 style={{ border: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`, borderRadius: 6, padding: '6px 12px 6px 34px', fontSize: 12, color: isDark ? '#e2e8f0' : T.ink, background: isDark ? '#0d0d0d' : T.surface, outline: 'none', fontFamily: sans, width: 220 }}
//                 placeholder="Search indicators..."
//                 value={search}
//                 onChange={e => { setSearch(e.target.value); setPage(1); }}
//               />
//             </div>

//             <div style={{ position: 'relative' }}>
//               <button
//                 onClick={() => setShowColMenu(v => !v)}
//                 style={{ background: isDark ? '#0d0d0d' : T.surface, border: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`, color: isDark ? '#94a3b8' : T.slate, fontSize: 12, fontWeight: 500, padding: '6px 12px', borderRadius: 6, cursor: 'pointer', fontFamily: sans, display: 'flex', alignItems: 'center', gap: 5 }}>
//                 <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                   <rect x="3" y="3" width="7" height="18"/><rect x="14" y="3" width="7" height="18"/>
//                 </svg>
//                 Columns
//               </button>
//               {showColMenu && (
//                 <div style={{ position: 'absolute', right: 0, top: '110%', background: isDark ? '#0d0d0d' : T.surface, border: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`, borderRadius: 8, padding: '10px 14px', zIndex: 100, width: 190, boxShadow: '0 4px 16px rgba(0,0,0,.1)' }}>
//                   {(Object.keys(cols) as (keyof typeof cols)[]).map(k => (
//                     <label key={k} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '5px 0', cursor: 'pointer', fontSize: 12, color: isDark ? '#e2e8f0' : T.ink }}>
//                       <input type="checkbox" checked={cols[k]}
//                         onChange={() => setCols(prev => ({ ...prev, [k]: !prev[k] }))}
//                         style={{ cursor: 'pointer' }} />
//                       {k.replace(/([A-Z])/g, ' $1').replace(/^./, s => s.toUpperCase())}
//                     </label>
//                   ))}
//                 </div>
//               )}
//             </div>

//             {activeFilterCount > 0 && (
//               <button onClick={clearFilters}
//                 style={{ background: isDark ? '#1a0a0a' : T.redBg, border: `1px solid ${isDark ? '#DC262640' : T.redBdr}`, color: T.red, fontSize: 11, fontWeight: 600, padding: '6px 12px', borderRadius: 6, cursor: 'pointer', fontFamily: sans, display: 'flex', alignItems: 'center', gap: 5 }}>
//                 ✕ Clear {activeFilterCount} filter{activeFilterCount > 1 ? 's' : ''}
//               </button>
//             )}
//           </div>

//           {/* ── Table ── */}
//           <div style={{ flex: 1, overflow: 'auto' }}>
//             <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
//               <colgroup>
//                 {cols.riskScore     && <col style={{ width: 90 }} />}
//                 {cols.indicator     && <col />}
//                 {cols.category      && <col style={{ width: '18%' }} />}
//                 {cols.source        && <col style={{ width: '14%' }} />}
//                 {cols.firstDetected && <col style={{ width: '13%' }} />}
//                 {cols.lastDetected  && <col style={{ width: '13%' }} />}
//                 {cols.status        && <col style={{ width: 100 }} />}
//               </colgroup>

//               <thead style={{ position: 'sticky', top: 0, zIndex: 5 }}>
//                 <tr style={{ background: isDark ? '#1a1a1a' : T.surface2, borderBottom: `1px solid ${isDark ? '#1f1f1f' : T.bdr}` }}>
//                   {cols.riskScore && (
//                     <th style={{ padding: '10px 14px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: isDark ? '#94a3b8' : T.slate, cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}>
//                       Risk Score <span style={{ color: isDark ? '#6b7280' : T.faint }}>⇅</span>
//                     </th>
//                   )}
//                   {cols.indicator && (
//                     <th style={{ padding: '10px 14px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: isDark ? '#94a3b8' : T.slate }}>Indicator</th>
//                   )}
//                   {cols.category && (
//                     <th style={{ padding: '10px 14px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: isDark ? '#94a3b8' : T.slate }}>Category</th>
//                   )}
//                   {cols.source && (
//                     <th style={{ padding: '10px 14px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: isDark ? '#94a3b8' : T.slate }}>Source</th>
//                   )}
//                   {cols.firstDetected && (
//                     <th style={{ padding: '10px 14px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: isDark ? '#94a3b8' : T.slate, cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}>
//                       First Detected <span style={{ color: isDark ? '#6b7280' : T.faint }}>⇅</span>
//                     </th>
//                   )}
//                   {cols.lastDetected && (
//                     <th style={{ padding: '10px 14px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: isDark ? '#94a3b8' : T.slate, cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' }}>
//                       Last Detected <span style={{ color: isDark ? '#6b7280' : T.faint }}>⇅</span>
//                     </th>
//                   )}
//                   {cols.status && (
//                     <th style={{ padding: '10px 14px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: isDark ? '#94a3b8' : T.slate }}>Status</th>
//                   )}
//                 </tr>
//               </thead>

//               <tbody>
//                 {pageItems.length === 0 ? (
//                   <tr>
//                     <td colSpan={7} style={{ textAlign: 'center', padding: '56px 0', fontSize: 13, color: isDark ? '#94a3b8' : T.muted }}>
//                       No indicators match your filters.
//                     </td>
//                   </tr>
//                 ) : pageItems.map((ind, idx) => {
//                   const globalIdx    = (page - 1) * perPage + idx;
//                   const displayScore = toDisplayScore(ind);
//                   const { bg, text, bdr } = getScoreBadgeColor(displayScore);
//                   const d1  = fmtDateShort(result.generated_at);
//                   const src = getSrc(ind.category);

//                   return (
//                     <tr
//                       key={globalIdx}
//                       onClick={() => openModal(ind)}
//                       onMouseEnter={e => (e.currentTarget as HTMLElement).style.background = isDark ? '#1a1a1a' : '#F8FAFC'}
//                       onMouseLeave={e => (e.currentTarget as HTMLElement).style.background = 'transparent'}
//                       style={{ borderBottom: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`, cursor: 'pointer', transition: 'background .1s' }}
//                     >
//                       {cols.riskScore && (
//                         <td style={{ padding: '12px 14px' }}>
//                           <div style={{
//                             display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
//                             width: 44, height: 32, borderRadius: 6,
//                             background: isDark ? `${text}20` : bg,
//                             border: `1px solid ${isDark ? `${text}40` : bdr}`,
//                             fontSize: 14, fontWeight: 700, color: text,
//                             fontFamily: sans,
//                           }}>
//                             {displayScore}
//                           </div>
//                         </td>
//                       )}
//                       {cols.indicator && (
//                         <td style={{ padding: '12px 14px' }}>
//                           <div style={{ fontSize: 13, fontWeight: 600, color: isDark ? '#e2e8f0' : T.ink }}>{ind.indicator_name}</div>
//                           <IndId name={ind.indicator_name} idx={globalIdx} isDark={isDark} />
//                         </td>
//                       )}
//                       {cols.category && (
//                         <td style={{ padding: '12px 14px' }}>
//                           <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
//                             <span style={{ fontSize: 14, lineHeight: 1 }}>{getCatIcon(ind.category)}</span>
//                             <span style={{ fontSize: 12, color: isDark ? '#94a3b8' : T.slate }}>{ind.category}</span>
//                           </div>
//                         </td>
//                       )}
//                       {cols.source && (
//                         <td style={{ padding: '12px 14px', fontSize: 12, color: isDark ? '#94a3b8' : T.slate }}>{src}</td>
//                       )}
//                       {cols.firstDetected && (
//                         <td style={{ padding: '12px 14px' }}>
//                           <div style={{ fontSize: 12, color: isDark ? '#e2e8f0' : T.ink }}>{d1.date}</div>
//                           <div style={{ fontSize: 11, color: isDark ? '#94a3b8' : T.muted, marginTop: 2 }}>{d1.time}</div>
//                         </td>
//                       )}
//                       {cols.lastDetected && (
//                         <td style={{ padding: '12px 14px' }}>
//                           <div style={{ fontSize: 12, color: isDark ? '#e2e8f0' : T.ink }}>{d1.date}</div>
//                           <div style={{ fontSize: 11, color: isDark ? '#94a3b8' : T.muted, marginTop: 2 }}>{d1.time}</div>
//                         </td>
//                       )}
//                       {cols.status && (
//                         <td style={{ padding: '12px 14px' }}>
//                           <StatusChip status="Active" isDark={isDark} />
//                         </td>
//                       )}
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </div>

//           {/* ── Pagination ── */}
//           <div style={{
//             background: isDark ? '#0d0d0d' : T.surface,
//             borderTop: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`,
//             padding: '12px 20px', display: 'flex', alignItems: 'center',
//             justifyContent: 'space-between', flexShrink: 0,
//           }}>
//             <span style={{ fontSize: 12, color: isDark ? '#94a3b8' : T.slate }}>
//               Showing {Math.min((page - 1) * perPage + 1, filteredInds.length)} to {Math.min(page * perPage, filteredInds.length)} of {filteredInds.length.toLocaleString()} results
//             </span>

//             <div style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
//               <button onClick={() => setPage(1)} disabled={page === 1}
//                 style={{ background: isDark ? '#0d0d0d' : T.surface, border: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`, color: page === 1 ? (isDark ? '#6b7280' : T.faint) : (isDark ? '#94a3b8' : T.slate), width: 32, height: 32, borderRadius: 6, cursor: page === 1 ? 'not-allowed' : 'pointer', fontSize: 13, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                 «
//               </button>
//               <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1}
//                 style={{ background: isDark ? '#0d0d0d' : T.surface, border: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`, color: page === 1 ? (isDark ? '#6b7280' : T.faint) : (isDark ? '#94a3b8' : T.slate), width: 32, height: 32, borderRadius: 6, cursor: page === 1 ? 'not-allowed' : 'pointer', fontSize: 13, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                 ‹
//               </button>

//               {(() => {
//                 const range: number[] = [];
//                 let start = Math.max(1, page - 2);
//                 let end   = Math.min(totalPages, page + 2);
//                 if (end - start < 4) {
//                   if (start === 1) end = Math.min(totalPages, 5);
//                   else start = Math.max(1, end - 4);
//                 }
//                 for (let i = start; i <= end; i++) range.push(i);
//                 return range.map(p => (
//                   <button key={p} onClick={() => setPage(p)}
//                     style={{ background: page === p ? (isDark ? '#3B82F6' : T.blue) : (isDark ? '#0d0d0d' : T.surface), border: `1px solid ${page === p ? (isDark ? '#3B82F6' : T.blue) : (isDark ? '#1f1f1f' : T.bdr)}`, color: page === p ? '#fff' : (isDark ? '#94a3b8' : T.slate), width: 32, height: 32, borderRadius: 6, cursor: 'pointer', fontSize: 12, fontWeight: page === p ? 700 : 400, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                     {p}
//                   </button>
//                 ));
//               })()}

//               {totalPages > 5 && page < totalPages - 2 && (
//                 <>
//                   <span style={{ fontSize: 12, color: isDark ? '#94a3b8' : T.muted, padding: '0 2px' }}>…</span>
//                   <button onClick={() => setPage(totalPages)}
//                     style={{ background: isDark ? '#0d0d0d' : T.surface, border: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`, color: isDark ? '#94a3b8' : T.slate, width: 32, height: 32, borderRadius: 6, cursor: 'pointer', fontSize: 12, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                     {totalPages}
//                   </button>
//                 </>
//               )}

//               <button onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages}
//                 style={{ background: isDark ? '#0d0d0d' : T.surface, border: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`, color: page === totalPages ? (isDark ? '#6b7280' : T.faint) : (isDark ? '#94a3b8' : T.slate), width: 32, height: 32, borderRadius: 6, cursor: page === totalPages ? 'not-allowed' : 'pointer', fontSize: 13, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                 ›
//               </button>
//               <button onClick={() => setPage(totalPages)} disabled={page === totalPages}
//                 style={{ background: isDark ? '#0d0d0d' : T.surface, border: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`, color: page === totalPages ? (isDark ? '#6b7280' : T.faint) : (isDark ? '#94a3b8' : T.slate), width: 32, height: 32, borderRadius: 6, cursor: page === totalPages ? 'not-allowed' : 'pointer', fontSize: 13, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                 »
//               </button>
//             </div>

//             <select value={perPage} onChange={e => { setPerPage(Number(e.target.value)); setPage(1); }}
//               style={{ border: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`, borderRadius: 6, padding: '5px 10px', fontSize: 12, color: isDark ? '#94a3b8' : T.slate, background: isDark ? '#0d0d0d' : T.surface, fontFamily: sans, cursor: 'pointer' }}>
//               {[10, 25, 50, 100].map(n => <option key={n} value={n}>{n} / page</option>)}
//             </select>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import api from '../../services/api';
import { useNavigate, useParams } from 'react-router-dom';
import ScanTypeButton, { ScanDepth } from '../../components/ScanTypeButton';
import { scanQueryOptions } from './ScanProgress';
import IndicatorDetailModal, { findingState } from '../../components/IndicatorDetailModal';
import RequestRemediationModal from '../Remediation/RequestRemediationModal';
import { remediationQueries } from '../../lib/queries';
import { useTheme as useCustomTheme } from '../../context/ThemeContext';
import { useAuth } from '../../context/AuthContext';

/* Scan results: one finished scan of one vendor. Layout (top to bottom): header with actions, host switcher (deep
   scans), overview (rating, open risks by severity, checks run), AI executive summary, score by category, findings
   (tabs, filter rail, table with bulk actions) and the finding detail panel. Facts that need other scans -- the
   previous score, trend, what changed, who started it, points per fix -- come from GET /scan/{id}/context. */

/* ─── Fonts ──────────────────────────────────────────────────────── */
if (typeof document !== 'undefined' && !document.getElementById('sr-fonts')) {
  const link = document.createElement('link');
  link.id = 'sr-fonts';
  link.rel = 'stylesheet';
  link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&family=JetBrains+Mono:wght@400;600;700&display=swap';
  document.head.appendChild(link);
}

const sans = "'Inter', system-ui, sans-serif";
const mono = "'JetBrains Mono', ui-monospace, monospace";

const palette = (d: boolean) => ({
  page: d ? '#000000' : '#F8FAFC',
  card: d ? '#0d0d0d' : '#FFFFFF',
  sunken: d ? '#111111' : '#FBFCFE',
  line: d ? '#1f1f1f' : '#E2E8F0',
  line2: d ? '#161616' : '#F1F5F9',
  ink: d ? '#e2e8f0' : '#0F172A',
  body: d ? '#cbd5e1' : '#334155',
  muted: d ? '#94a3b8' : '#64748B',
  faint: d ? '#6b7280' : '#94A3B8',
  blue: d ? '#60A5FA' : '#185FA5',
  blueBg: d ? '#0c2a4a' : '#E6F1FB',
  blueInk: d ? '#BFDBFE' : '#0C447C',
  hover: d ? '#141414' : '#F8FAFC',
  sel: d ? '#0b1a2e' : '#F5F9FE',
  ai: d ? '#A78BFA' : '#7C3AED',
  aiBg: d ? '#241b3d' : '#F5F3FF',
  ok: '#16A34A',
  dark: d,
});
type Pal = ReturnType<typeof palette>;

const SEV_COLOR: Record<string, string> = { Critical: '#DC2626', High: '#EA580C', Medium: '#D97706', Low: '#CA8A04' };
const SEVERITIES = ['Critical', 'High', 'Medium', 'Low'] as const;
const tint = (color: string, p: Pal) => `${color}${p.dark ? '26' : '14'}`;

const grade = (s: number) => (s >= 90 ? 'A' : s >= 80 ? 'B' : s >= 70 ? 'C' : s >= 60 ? 'D' : 'F');
const riskColor = (level: string) => {
  const l = (level || '').toLowerCase();
  if (l === 'critical') return '#DC2626';
  if (l === 'high') return '#EA580C';
  if (l === 'medium') return '#D97706';
  if (l === 'low') return '#16A34A';
  return '#94A3B8';
};
const scoreColor = (s: number) => (s >= 80 ? '#16A34A' : s >= 60 ? '#D97706' : s >= 40 ? '#EA580C' : '#DC2626');

/* Categories that never carry risk (always 100): left out of "Score by category". */
const INFO_ONLY_CATS = new Set(['Company Profile', 'Funding & Ownership']);

/* ─── Known category buckets (filter rail) ───────────────────────── */
const CYBER_CATS = [
  'Advanced Cloud Security', 'Attack Surface Security', 'Domain & DNS',
  'Domain & DNS Security', 'Identity Threat Intelligence',
  'Infrastructure & Network Security', 'Network Attack Surface',
  'TLS Encryption Security', 'TLS/Encryption', 'Web Application Technology',
  'Security Certifications', 'Cloud Security', 'Network Security',
  'Web Security', 'Encryption Security', 'Email Security',
  'Subdomain Security', 'Vulnerability Intelligence', 'DNS Security',
  'Threat Intelligence', 'Application Security', 'Cubit Score',
  'Patching Cadence', 'Encryption & SSL', 'Best Practice',
  'Vulnerability', 'Informational',
];
const OPS_CATS = ['Company Profile', 'Funding & Ownership', 'Reputation & ESG', 'Legal & Regulatory', 'Market Intelligence', 'Compliance'];
const isCyberCat = (cat: string) => CYBER_CATS.some(c => cat.toLowerCase().includes(c.toLowerCase()) || c.toLowerCase().includes(cat.toLowerCase()));
const isOpsCat = (cat: string) => OPS_CATS.some(c => cat === c || cat.includes(c));

// Where the check got its data, as the scanner recorded it in the evidence ('DNS', 'OSV.dev' ...). Nothing inferred.
const getSrc = (ind: { evidence?: any }) => {
  const s = ind.evidence && typeof ind.evidence === 'object' ? ind.evidence.source : null;
  return s ? String(s).replace(/[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE0F}]/gu, '').trim() : '';
};

/* ─── Types ──────────────────────────────────────────────────────── */
interface Indicator {
  indicator_name: string;
  category: string;
  severity: string;
  score_impact: number;
  description: string;
  recommendation: string;
  evidence?: any;
  isPlaceholder?: boolean;
  deprioritized?: boolean;
  original_severity?: string;
  /** When the check entered its current state, from the host's earlier scans (server: _annotate_first_seen). */
  first_seen?: string;
}

interface DomainResult {
  domain: string;
  is_primary: boolean;
  overall_score: number;
  risk_level: string;
  category_scores: Record<string, number>;
  indicators: Indicator[];
  generated_at?: string;
}

interface ScanContext {
  previous: { id: string; score: number; date: string } | null;
  trend: { id: string; score: number; date: string }[];
  changes: { new: string[]; worse: string[]; better: string[]; resolved: string[] } | null;
  started_by: string | null;
  trigger_source: string | null;
  duration_seconds: number | null;
  score_gains: Record<string, number>;
}

type Tab = 'open' | 'passed' | 'nottested' | 'all';
type SortKey = 'risk' | 'risk-asc' | 'name' | 'category' | 'first';

/* ─── Small pieces ───────────────────────────────────────────────── */
const fmtDate = (iso?: string | null, withTime = false) => {
  const d = new Date(iso || '');
  if (!iso || isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', ...(withTime ? { hour: '2-digit', minute: '2-digit' } : {}) });
};
const fmtDuration = (s?: number | null) => (s == null ? null : s < 60 ? `${s}s` : s < 3600 ? `${Math.floor(s / 60)}m ${s % 60}s` : `${Math.floor(s / 3600)}h ${Math.floor((s % 3600) / 60)}m`);
const keyOf = (i: Indicator) => `${i.category}|${i.indicator_name}`;
const checkRisk = (ind: Indicator) => Math.min(10, Math.round(Math.abs(Number(ind.score_impact) || 0) * 10) / 10);

function downloadFile(name: string, body: string, type: string) {
  const a = document.createElement('a');
  a.href = URL.createObjectURL(new Blob([body], { type }));
  a.download = name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 2000);
}
// Cells starting with = + - @ are prefixed so a spreadsheet never runs them as formulas.
const csvCell = (v: unknown) => {
  let s = v == null ? '' : String(v);
  if (/^[=+\-@]/.test(s)) s = `'${s}`;
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

const Card = ({ p, children, style }: { p: Pal; children: React.ReactNode; style?: React.CSSProperties }) => (
  <div style={{ background: p.card, border: `1px solid ${p.line}`, borderRadius: 12, ...style }}>{children}</div>
);

const Chip = ({ color, p, children, title, style }: { color: string; p: Pal; children: React.ReactNode; title?: string; style?: React.CSSProperties }) => (
  <span title={title} style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '2px 9px', borderRadius: 999, fontSize: 11.5, fontWeight: 600,
    whiteSpace: 'nowrap', color, background: tint(color, p), ...style }}>{children}</span>
);

const Dot = ({ color, size = 6 }: { color: string; size?: number }) => (
  <span style={{ width: size, height: size, borderRadius: '50%', background: color, display: 'inline-block', flexShrink: 0 }} />
);

const btn = (p: Pal, kind: 'default' | 'primary' | 'ghost' = 'default'): React.CSSProperties => ({
  fontFamily: sans, fontSize: 12.5, fontWeight: 600, borderRadius: 8, padding: '7px 12px', cursor: 'pointer', whiteSpace: 'nowrap',
  display: 'inline-flex', alignItems: 'center', gap: 6, lineHeight: 1.2,
  ...(kind === 'primary' ? { background: '#185FA5', border: '1px solid #185FA5', color: '#fff' }
    : kind === 'ghost' ? { background: 'transparent', border: '1px solid transparent', color: p.muted }
    : { background: p.card, border: `1px solid ${p.line}`, color: p.ink }),
});

const Check = ({ checked, partial, onChange, p, label }: { checked: boolean; partial?: boolean; onChange: () => void; p: Pal; label: string }) => (
  <span role="checkbox" aria-checked={partial ? 'mixed' : checked} aria-label={label} tabIndex={0}
    onClick={e => { e.stopPropagation(); onChange(); }}
    onKeyDown={e => { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); onChange(); } }}
    style={{ width: 15, height: 15, borderRadius: 4, flexShrink: 0, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      border: `1.5px solid ${checked || partial ? '#185FA5' : (p.dark ? '#3a3a3a' : '#CBD5E1')}`, background: checked || partial ? '#185FA5' : p.card }}>
    {checked && <svg width="9" height="9" viewBox="0 0 12 12"><polyline points="2,6 5,9 10,3" stroke="#fff" strokeWidth="2.2" fill="none" strokeLinecap="round" strokeLinejoin="round" /></svg>}
    {!checked && partial && <span style={{ width: 7, height: 2, background: '#fff', borderRadius: 1 }} />}
  </span>
);

/** A small dropdown menu: a button that opens a list of actions; closes on outside click or Escape. */
function Menu({ p, label, items, align = 'right', buttonStyle }: {
  p: Pal; label: React.ReactNode; align?: 'left' | 'right'; buttonStyle?: React.CSSProperties;
  items: { label: string; hint?: string; onClick: () => void; disabled?: boolean }[];
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const down = (e: MouseEvent) => { if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false); };
    const key = (e: KeyboardEvent) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', down);
    document.addEventListener('keydown', key);
    return () => { document.removeEventListener('mousedown', down); document.removeEventListener('keydown', key); };
  }, [open]);
  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button type="button" style={{ ...btn(p), ...buttonStyle }} aria-haspopup="menu" aria-expanded={open} onClick={() => setOpen(o => !o)}>
        {label} <span style={{ fontSize: 9, opacity: 0.7 }}>▼</span>
      </button>
      {open && (
        <div role="menu" style={{ position: 'absolute', top: 'calc(100% + 6px)', [align]: 0, zIndex: 300, minWidth: 220, background: p.card,
          border: `1px solid ${p.line}`, borderRadius: 10, padding: 6, boxShadow: p.dark ? '0 10px 30px rgba(0,0,0,.6)' : '0 10px 30px rgba(15,23,42,.12)' }}>
          {items.map(it => (
            <button key={it.label} type="button" role="menuitem" disabled={it.disabled}
              onClick={() => { setOpen(false); it.onClick(); }}
              style={{ display: 'block', width: '100%', textAlign: 'left', background: 'transparent', border: 'none', borderRadius: 7, padding: '8px 10px',
                cursor: it.disabled ? 'default' : 'pointer', fontFamily: sans, color: it.disabled ? p.faint : p.ink }}
              onMouseEnter={e => { if (!it.disabled) e.currentTarget.style.background = p.hover; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}>
              <div style={{ fontSize: 12.5, fontWeight: 600 }}>{it.label}</div>
              {it.hint && <div style={{ fontSize: 11.5, color: p.muted, marginTop: 2 }}>{it.hint}</div>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

const ScoreRing = ({ score, color, p }: { score: number; color: string; p: Pal }) => {
  const r = 50, circ = 2 * Math.PI * r, dash = (Math.max(0, Math.min(100, score)) / 100) * circ;
  return (
    <svg width="120" height="120" viewBox="0 0 120 120" role="img" aria-label={`Security rating ${score} out of 100`} style={{ flexShrink: 0 }}>
      <circle cx="60" cy="60" r={r} fill="none" stroke={p.dark ? '#1f1f1f' : '#EEF2F7'} strokeWidth="11" />
      <circle cx="60" cy="60" r={r} fill="none" stroke={color} strokeWidth="11" strokeLinecap="round"
        strokeDasharray={`${dash} ${circ - dash}`} transform="rotate(-90 60 60)" style={{ transition: 'stroke-dasharray .6s ease' }} />
      <text x="60" y="60" textAnchor="middle" fontSize="30" fontWeight="700" fill={p.ink} fontFamily={sans}>{score}</text>
      <text x="60" y="79" textAnchor="middle" fontSize="11" fill={p.muted} fontFamily={sans}>out of 100</text>
    </svg>
  );
};

const Sparkline = ({ points, p }: { points: number[]; p: Pal }) => {
  if (points.length < 2) return null;
  const w = 150, h = 30, min = Math.min(...points), max = Math.max(...points), span = max - min || 1;
  const xy = points.map((v, i) => [2 + (i * (w - 6)) / (points.length - 1), h - 4 - ((v - min) / span) * (h - 10)]);
  const last = xy[xy.length - 1];
  return (
    <svg width={w} height={h} aria-hidden="true">
      <polyline fill="none" stroke={p.blue} strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" points={xy.map(([x, y]) => `${x},${y}`).join(' ')} />
      <circle cx={last[0]} cy={last[1]} r="3" fill={p.blue} />
    </svg>
  );
};

/* ─── Main ───────────────────────────────────────────────────────── */
export default function ScanResults() {
  const { scanId } = useParams();
  const navigate = useNavigate();
  const { mode } = useCustomTheme();
  const isDark = mode === 'dark';
  const p = palette(isDark);
  const { refreshTenant, user } = useAuth();
  const canEdit = !!user && user.role !== 'viewer';
  const queryClient = useQueryClient();

  const [pickedDomain, setSelectedDomain] = useState('');
  const [tab, setTab] = useState<Tab | null>(null);
  const [sevFilter, setSevFilter] = useState<string[]>([]);
  const [catFilter, setCatFilter] = useState<Set<string>>(new Set());
  const [search, setSearch] = useState('');
  const [newOnly, setNewOnly] = useState(false);
  const [groupByCat, setGroupByCat] = useState(false);
  const [sortKey, setSortKey] = useState<SortKey>('risk');
  const [cyberExpanded, setCyberExpanded] = useState(false);
  const [opsExpanded, setOpsExpanded] = useState(false);
  const [catsExpanded, setCatsExpanded] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(25);
  const [showFilterPane, setShowFilterPane] = useState(true);
  const [cols, setCols] = useState({ riskScore: true, indicator: true, category: true, status: true, firstDetected: true, lastDetected: true, source: true });
  const [selInd, setSelInd] = useState<Indicator | null>(null);
  const [selected, setSelected] = useState<Set<string>>(new Set());
  const [remediateNames, setRemediateNames] = useState<string[] | null>(null);
  const [summaryCollapsed, setSummaryCollapsed] = useState(false);
  const [toast, setToast] = useState<{ text: string; tone: 'ok' | 'error' } | null>(null);
  const [copied, setCopied] = useState<string | null>(null);

  useEffect(() => { refreshTenant(); /* plan gating display only */ // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scanId]);
  useEffect(() => { if (!toast) return; const t = setTimeout(() => setToast(null), 4500); return () => clearTimeout(t); }, [toast]);
  useEffect(() => { if (!copied) return; const t = setTimeout(() => setCopied(null), 1800); return () => clearTimeout(t); }, [copied]);

  // A completed scan never changes, so it is not refetched on its own; realtime scan events still invalidate it.
  const scanQuery = useQuery({
    ...scanQueryOptions(scanId ?? ''),
    enabled: !!scanId,
    staleTime: 30 * 60_000,
    retry: (count, err: any) => err?.response?.status !== 404 && count < 1,
  });
  const data = scanQuery.data;
  const isProcessing = data?.status === 'processing';

  const redirectedRef = useRef(false);
  useEffect(() => {
    if (!isProcessing || redirectedRef.current) return;
    redirectedRef.current = true;
    setTimeout(() => navigate(`/scans/${scanId}/progress`), 2000);
  }, [isProcessing, scanId, navigate]);

  const contextQuery = useQuery({
    queryKey: ['scan', scanId, 'context'],
    queryFn: async () => (await api.get(`/v1/scan/${scanId}/context`)).data as ScanContext,
    enabled: !!scanId && !!data && !isProcessing,
    staleTime: 5 * 60_000,
    retry: false,
  });
  const ctx = contextQuery.data;

  const primaryDomainName: string | undefined = data ? (data.primary_domain || data.domain) : undefined;
  const vendorLookupQuery = useQuery({
    queryKey: ['vendors', 'by-domain', primaryDomainName],
    queryFn: async () => (await api.get(`/v1/vendors/by-domain/${primaryDomainName}`)).data,
    enabled: !!data && !isProcessing && !!primaryDomainName && !data.vendor_id,
    retry: false,
  });
  const vendorId: string | undefined = data?.vendor_id || vendorLookupQuery.data?.id;

  const vendorRisksQuery = useQuery({ ...remediationQueries.vendorRisks(vendorId ?? ''), enabled: !!vendorId });
  const inRemediation = vendorRisksQuery.data || {};

  const domainResults = useMemo<DomainResult[]>(() => {
    if (!data || isProcessing) return [];
    let domains: DomainResult[] = data.domain_results || [];
    if (!domains.length && data.indicators) {
      domains = [{
        domain: data.primary_domain || data.domain, is_primary: true, overall_score: data.overall_score, risk_level: data.risk_level,
        category_scores: data.category_scores || {}, indicators: data.indicators || [], generated_at: data.generated_at,
      }];
    }
    return domains;
  }, [data, isProcessing]);
  const primaryResult = domainResults.find(d => d.is_primary) || domainResults[0];
  const selectedDomain = domainResults.some(d => d.domain === pickedDomain) ? pickedDomain : (primaryResult?.domain ?? '');
  const domainData = domainResults.find(d => d.domain === selectedDomain) || domainResults[0];
  const onPrimary = !!domainData && domainData === primaryResult;
  const allIndicators = useMemo<Indicator[]>(() => domainData?.indicators || [], [domainData]);

  const aiSummaryMutation = useMutation({
    mutationFn: async () => (await api.post(`/v1/scan/${scanId}/ai-summary`)).data,
    onSuccess: res => queryClient.setQueryData(['scan', scanId], (old: any) => old ? { ...old, ai_summary: res.summary, ai_summary_generated_at: new Date().toISOString() } : old),
    meta: { invalidates: [['scan', scanId]] },
  });
  const aiSummaryError: string | null = aiSummaryMutation.isError
    ? (() => {
        const d = (aiSummaryMutation.error as any)?.response?.data?.detail;
        return typeof d === 'string' ? d : (d && typeof d === 'object' && typeof d.message === 'string') ? d.message : "Couldn't write the summary.";
      })()
    : null;
  const generateSummary = () => { if (scanId) { setSummaryCollapsed(false); aiSummaryMutation.mutate(); } };

  // Through the vendor it belongs to when there is one (tenant-isolated, audit-logged, queued), else an ad-hoc rescan.
  const rescanMutation = useMutation({
    mutationFn: async (scanType: ScanDepth) => {
      if (vendorId) return (await api.post(`/v1/vendors/${vendorId}/trigger-scan`, null, { params: { scan_type: scanType } })).data as { scan_id: string };
      return (await api.post('/v1/scan', { company_name: data?.company_name, domain: primaryDomainName, scan_type: scanType })).data as { scan_id: string };
    },
    onSuccess: res => navigate(`/scans/${res.scan_id}/progress`),
    onError: (err: any) => {
      const d = err?.response?.data?.detail;
      setToast({ tone: 'error', text: typeof d === 'string' ? d : (d && typeof d === 'object' && typeof d.message === 'string') ? d.message : "Couldn't start a new scan." });
    },
    meta: { invalidates: [['scans']] },
  });

  const recheckMutation = useMutation({
    mutationFn: async (inds: Indicator[]) => {
      let started = 0, failed = 0, firstError = '';
      for (const ind of inds) {
        try {
          await api.post('/v1/indicator-intel/recheck', { scan_id: scanId, name: ind.indicator_name, category: ind.category, target: selectedDomain });
          started++;
        } catch (e: any) {
          failed++;
          const d = e?.response?.data?.detail;
          if (!firstError) firstError = typeof d === 'string' ? d : '';
        }
      }
      return { started, failed, firstError };
    },
    onSuccess: ({ started, failed, firstError }) => setToast(failed && !started
      ? { tone: 'error', text: firstError || "Couldn't start the re-checks." }
      : { tone: 'ok', text: `Re-checking ${started} finding${started === 1 ? '' : 's'}. Open a finding to see its result.${failed ? ` ${failed} couldn't be started.` : ''}` }),
  });

  /* ── Derived lists ── */
  const stateOf = useMemo(() => {
    const m = new Map<string, { label: string; color: string }>();
    allIndicators.forEach(i => m.set(keyOf(i), findingState(i)));
    return m;
  }, [allIndicators]);
  const tabOf = (i: Indicator): Exclude<Tab, 'all'> => {
    const label = stateOf.get(keyOf(i))?.label;
    return label === 'Passed' ? 'passed' : label === 'Not tested' ? 'nottested' : 'open';
  };
  const tabCounts = useMemo(() => {
    const c = { open: 0, passed: 0, nottested: 0, all: allIndicators.length };
    allIndicators.forEach(i => { c[tabOf(i)]++; });
    return c;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allIndicators, stateOf]);
  const activeTab: Tab = tab ?? (tabCounts.open > 0 ? 'open' : 'all');

  const sevCounts = useMemo(() => {
    const c: Record<string, number> = { Critical: 0, High: 0, Medium: 0, Low: 0 };
    allIndicators.forEach(i => { const l = stateOf.get(keyOf(i))?.label || ''; if (l in c) c[l]++; });
    return c;
  }, [allIndicators, stateOf]);

  const changes = onPrimary ? ctx?.changes ?? null : null;
  const newSet = useMemo(() => new Set(changes?.new || []), [changes]);
  const worseSet = useMemo(() => new Set(changes?.worse || []), [changes]);

  const inTab = useMemo(() => allIndicators.filter(i => activeTab === 'all' || tabOf(i) === activeTab),
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [allIndicators, activeTab, stateOf]);

  const catCount = useMemo(() => {
    const m: Record<string, number> = {};
    inTab.forEach(i => { m[i.category] = (m[i.category] || 0) + 1; });
    return m;
  }, [inTab]);
  const allCats = useMemo(() => Array.from(new Set(allIndicators.map(i => i.category))).sort(), [allIndicators]);
  const cyberCats = allCats.filter(isCyberCat);
  const opsCats = allCats.filter(isOpsCat);
  const otherCats = allCats.filter(c => !isCyberCat(c) && !isOpsCat(c));
  const sevInTab = useMemo(() => {
    const c: Record<string, number> = { Critical: 0, High: 0, Medium: 0, Low: 0 };
    inTab.forEach(i => { const l = stateOf.get(keyOf(i))?.label || ''; if (l in c) c[l]++; });
    return c;
  }, [inTab, stateOf]);

  const filtered = useMemo(() => {
    const s = search.trim().toLowerCase();
    const list = inTab.filter(i =>
      (!s || i.indicator_name.toLowerCase().includes(s) || (i.description || '').toLowerCase().includes(s) || i.category.toLowerCase().includes(s)) &&
      (sevFilter.length === 0 || sevFilter.includes(stateOf.get(keyOf(i))?.label || '')) &&
      (catFilter.size === 0 || catFilter.has(i.category)) &&
      (!newOnly || newSet.has(i.indicator_name)));
    const byRisk = (a: Indicator, b: Indicator) => checkRisk(b) - checkRisk(a) || a.indicator_name.localeCompare(b.indicator_name);
    const sorters: Record<SortKey, (a: Indicator, b: Indicator) => number> = {
      risk: byRisk,
      'risk-asc': (a, b) => -byRisk(a, b),
      name: (a, b) => a.indicator_name.localeCompare(b.indicator_name),
      category: (a, b) => a.category.localeCompare(b.category) || byRisk(a, b),
      first: (a, b) => (new Date(b.first_seen || 0).getTime() - new Date(a.first_seen || 0).getTime()) || byRisk(a, b),
    };
    list.sort(groupByCat ? (a, b) => a.category.localeCompare(b.category) || sorters[sortKey](a, b) : sorters[sortKey]);
    return list;
  }, [inTab, search, sevFilter, catFilter, newOnly, newSet, sortKey, groupByCat, stateOf]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / perPage));
  const safePage = Math.min(page, totalPages);
  const pageItems = filtered.slice((safePage - 1) * perPage, safePage * perPage);

  // Selection follows the visible host; switching host or tab clears it.
  useEffect(() => { setSelected(new Set()); }, [selectedDomain, activeTab]);
  useEffect(() => { setPage(1); }, [selectedDomain, activeTab, search, sevFilter, catFilter, newOnly, sortKey, groupByCat, perPage]);

  const categoryRows = useMemo(() => {
    const scores = domainData?.category_scores || {};
    const risks: Record<string, number> = {};
    allIndicators.forEach(i => { if (tabOf(i) === 'open') risks[i.category] = (risks[i.category] || 0) + 1; });
    return Object.entries(scores)
      .filter(([cat, v]) => !INFO_ONLY_CATS.has(cat) && typeof v === 'number')
      .map(([cat, v]) => ({ cat, score: Math.round(v as number), risks: risks[cat] || 0 }))
      .sort((a, b) => a.score - b.score || b.risks - a.risks);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [domainData, allIndicators, stateOf]);

  /* ── Filter helpers ── */
  const toggleIn = <T,>(set: Set<T>, v: T) => { const n = new Set(set); if (n.has(v)) n.delete(v); else n.add(v); return n; };
  const toggleSev = (sev: string) => setSevFilter(prev => prev.includes(sev) ? prev.filter(s => s !== sev) : [...prev, sev]);
  const toggleGroup = (group: string[]) => {
    const all = group.every(c => catFilter.has(c));
    setCatFilter(prev => { const n = new Set(prev); group.forEach(c => (all ? n.delete(c) : n.add(c))); return n; });
  };
  const clearFilters = () => { setSevFilter([]); setCatFilter(new Set()); setSearch(''); setNewOnly(false); };
  const activeFilterCount = sevFilter.length + catFilter.size + (search ? 1 : 0) + (newOnly ? 1 : 0);
  const scrollToFindings = () => document.getElementById('scan-findings')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  const showSeverity = (sev: string) => {
    setTab('open');
    setSevFilter(sevFilter.length === 1 && sevFilter[0] === sev ? [] : [sev]);
    scrollToFindings();
  };
  const showCategory = (cat: string) => { setTab('open'); setCatFilter(new Set([cat])); scrollToFindings(); };

  /* ── Selection ── */
  const pageKeys = pageItems.map(keyOf);
  const allOnPage = pageKeys.length > 0 && pageKeys.every(k => selected.has(k));
  const someOnPage = pageKeys.some(k => selected.has(k));
  const selectedInds = allIndicators.filter(i => selected.has(keyOf(i)));
  const selectedOpen = selectedInds.filter(i => tabOf(i) === 'open');

  /* ── Exports ── */
  const exportCsv = (inds: Indicator[], suffix: string) => {
    const head = ['Finding', 'Check key', 'Category', 'Status', 'Risk (0-10)', 'First detected', 'Last checked', 'Source', 'Host', 'Recommendation'];
    const rows = inds.map(i => [i.indicator_name, i.evidence?.indicator || '', i.category, stateOf.get(keyOf(i))?.label || '', checkRisk(i),
      i.first_seen ? fmtDate(i.first_seen) : '', fmtDate(completedAt), getSrc(i), selectedDomain, (i.recommendation || '').replace(/\s+/g, ' ')]);
    const body = '﻿' + [head, ...rows].map(r => r.map(csvCell).join(',')).join('\n');
    downloadFile(`${(data?.company_name || 'scan').replace(/[^\w.-]+/g, '_')}_${suffix}.csv`, body, 'text/csv;charset=utf-8');
  };

  /* ── Loading / error ── */
  if (scanQuery.isPending && !!scanId) return (
    <div style={{ fontFamily: sans, background: p.page, minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: 12 }}>
      <style>{`@keyframes slide{from{transform:translateX(-40px)}to{transform:translateX(80px)}}`}</style>
      <span style={{ fontSize: 12, color: p.muted, letterSpacing: '.08em' }}>Loading scan results…</span>
      <div style={{ width: 160, height: 2, background: p.line, borderRadius: 2, overflow: 'hidden' }}>
        <div style={{ width: '60%', height: 2, background: '#185FA5', borderRadius: 2, animation: 'slide 1.2s ease-in-out infinite alternate' }} />
      </div>
    </div>
  );

  const error: string | null = isProcessing ? 'Scan in progress — redirecting…'
    : (!data && scanQuery.isError) ? ((scanQuery.error as any)?.response?.status === 404 ? 'Scan not found.' : "Couldn't load the results.") : null;
  if (error || !data || !domainData) return (
    <div style={{ fontFamily: sans, background: p.page, minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center', maxWidth: 360 }}>
        <div style={{ fontSize: 13, color: '#DC2626', marginBottom: 12, padding: '10px 16px', background: tint('#DC2626', p), borderRadius: 8 }}>{error || 'Scan results not found.'}</div>
        <button style={btn(p, 'primary')} onClick={() => navigate('/vendors')}>Back to vendors</button>
      </div>
    </div>
  );

  const companyName: string = data.company_name || primaryDomainName || 'Scan';
  const completedAt: string | undefined = data.completed_at || data.generated_at || data.created_at;
  const isPaid = !data.plan_locked;
  const lockedCount = isPaid ? 0 : (data.locked_indicators || 0);
  const totalChecks = isPaid ? allIndicators.length : (data.total_indicators || allIndicators.length);
  const score = Math.round(domainData.overall_score || 0);
  const riskLevel = domainData.risk_level || 'Unknown';
  const scanRef: string = data.scan_ref || data.scan_id;
  const scanType = (data.scan_type || '').toLowerCase().includes('deep') ? 'Deep scan' : (data.scan_type || '').toLowerCase().includes('fast') ? 'Fast scan' : (data.scan_type || 'Scan');
  const prevScore = onPrimary ? ctx?.previous?.score : undefined;
  const delta = typeof prevScore === 'number' ? Math.round(score - prevScore) : null;
  const trend = onPrimary ? (ctx?.trend || []).map(t => t.score) : [];
  const startedBy = ctx?.started_by || (ctx?.trigger_source === 'scheduled' ? 'Schedule' : ctx?.trigger_source === 'onboarding' ? 'Vendor onboarding' : null);
  const duration = fmtDuration(ctx?.duration_seconds);
  const aiSummary: string | null = data.ai_summary || null;
  const summaryAt: string | null = data.ai_summary_generated_at || null;
  const passedPct = totalChecks ? (tabCounts.passed / allIndicators.length) * 100 : 0;
  const openPct = allIndicators.length ? (tabCounts.open / allIndicators.length) * 100 : 0;
  const ntPct = allIndicators.length ? (tabCounts.nottested / allIndicators.length) * 100 : 0;

  const copy = (text: string, what: string) => { navigator.clipboard?.writeText(text).then(() => setCopied(what)).catch(() => undefined); };

  const th: React.CSSProperties = { padding: '10px 12px', textAlign: 'left', fontSize: 11.5, fontWeight: 600, color: p.muted, background: p.sunken,
    borderBottom: `1px solid ${p.line}`, whiteSpace: 'nowrap', position: 'sticky', top: 0, zIndex: 2 };
  const td: React.CSSProperties = { padding: '11px 12px', borderBottom: `1px solid ${p.line2}`, verticalAlign: 'middle' };
  const railTitle: React.CSSProperties = { fontSize: 11, fontWeight: 700, color: p.faint, letterSpacing: '.06em', textTransform: 'uppercase', marginBottom: 8 };
  const railRow = (active: boolean): React.CSSProperties => ({ display: 'flex', alignItems: 'center', gap: 8, padding: '5px 0', fontSize: 12.5, color: active ? p.ink : p.body, cursor: 'pointer', userSelect: 'none' });

  const tabs: { id: Tab; label: string }[] = [
    { id: 'open', label: 'Open risks' }, { id: 'passed', label: 'Passed' }, { id: 'nottested', label: 'Not tested' }, { id: 'all', label: 'All' },
  ];

  const CatGroup = ({ title, cats, expanded, setExpanded }: { title: string; cats: string[]; expanded: boolean; setExpanded: (v: boolean) => void }) => {
    if (!cats.length) return null;
    const shown = expanded ? cats : cats.slice(0, 5);
    const all = cats.every(c => catFilter.has(c));
    const some = cats.some(c => catFilter.has(c));
    return (
      <div style={{ padding: '14px 16px', borderBottom: `1px solid ${p.line2}` }}>
        <div style={{ ...railRow(some), padding: '0 0 8px' }} onClick={() => toggleGroup(cats)}>
          <Check p={p} checked={all} partial={!all && some} onChange={() => toggleGroup(cats)} label={`All ${title}`} />
          <span style={{ ...railTitle, marginBottom: 0 }}>{title}</span>
        </div>
        {shown.map(c => (
          <div key={c} style={railRow(catFilter.has(c))} onClick={() => setCatFilter(prev => toggleIn(prev, c))}>
            <Check p={p} checked={catFilter.has(c)} onChange={() => setCatFilter(prev => toggleIn(prev, c))} label={c} />
            <span style={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{c}</span>
            <span style={{ fontSize: 11.5, color: p.faint, fontWeight: 600 }}>{catCount[c] || 0}</span>
          </div>
        ))}
        {cats.length > 5 && (
          <button type="button" onClick={() => setExpanded(!expanded)} style={{ ...btn(p, 'ghost'), padding: '4px 0', color: p.blue }}>
            {expanded ? 'Show less' : `Show ${cats.length - 5} more`}
          </button>
        )}
      </div>
    );
  };

  /* ─────────────────── RENDER ─────────────────────────────────── */
  return (
    <div style={{ fontFamily: sans, background: p.page, minHeight: '100vh', color: p.ink }}>
      <IndicatorDetailModal
        open={!!selInd}
        onClose={() => setSelInd(null)}
        indicator={selInd as any}
        vendorName={companyName}
        domain={selectedDomain}
        vendorIp={data.resolved_ip}
        vendorId={vendorId}
        scanId={scanId}
        list={filtered as any}
        onNavigate={(ind: any) => setSelInd(ind)}
        variant="drawer"
        scoreGain={selInd && onPrimary ? ctx?.score_gains?.[selInd.indicator_name] ?? null : null}
      />
      {remediateNames && vendorId && (
        <RequestRemediationModal isDark={isDark} vendor={{ id: vendorId, name: companyName, domain: primaryDomainName }}
          preselected={remediateNames} onClose={() => setRemediateNames(null)}
          onCreated={requestId => { setRemediateNames(null); setSelected(new Set()); navigate(`/remediation/${requestId}`); }} />
      )}
      {toast && (
        <div role={toast.tone === 'error' ? 'alert' : 'status'} style={{ position: 'fixed', bottom: 20, right: 20, zIndex: 1400, maxWidth: 380, padding: '10px 14px',
          borderRadius: 10, fontSize: 12.5, background: toast.tone === 'error' ? tint('#DC2626', p) : p.card, color: toast.tone === 'error' ? '#DC2626' : p.ink,
          border: `1px solid ${toast.tone === 'error' ? '#FECACA' : p.line}`, boxShadow: p.dark ? '0 8px 30px rgba(0,0,0,.7)' : '0 8px 24px rgba(15,23,42,.12)' }}>
          {toast.text}
        </div>
      )}

      <div style={{ width: '100%', boxSizing: 'border-box', padding: '16px 20px 48px' }}>
        {/* Breadcrumb */}
        <nav aria-label="Breadcrumb" style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: p.muted, marginBottom: 12 }}>
          <span style={{ color: p.blue, fontWeight: 500, cursor: 'pointer' }} onClick={() => navigate('/vendors')}>Vendors</span>
          <span>›</span>
          {vendorId
            ? <span style={{ color: p.blue, fontWeight: 500, cursor: 'pointer' }} onClick={() => navigate(`/vendors/${vendorId}`)}>{companyName}</span>
            : <span>{companyName}</span>}
          <span>›</span>
          <span style={{ color: p.ink, fontWeight: 600 }}>Scan results</span>
        </nav>

        {/* 1 Header */}
        <Card p={p} style={{ padding: '18px 20px', display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
          <div style={{ width: 46, height: 46, borderRadius: 10, border: `1px solid ${p.line}`, background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, overflow: 'hidden' }}>
            <img src={`https://www.google.com/s2/favicons?domain=${encodeURIComponent(primaryDomainName || '')}&sz=64`} alt="" width={26} height={26}
              onError={e => { (e.target as HTMLImageElement).style.display = 'none'; }} />
          </div>
          <div style={{ minWidth: 0, flex: 1 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
              <h1 style={{ margin: 0, fontSize: 20, fontWeight: 700, color: p.ink }}>{companyName}</h1>
              <span style={{ fontSize: 13, color: p.muted }}>{primaryDomainName}</span>
              <Chip color={p.ok} p={p}><Dot color={p.ok} />Completed</Chip>
            </div>
            <div style={{ display: 'flex', gap: 14, marginTop: 6, flexWrap: 'wrap', fontSize: 12, color: p.muted }}>
              <span>{fmtDate(completedAt, true)}</span>
              <span>{scanType}</span>
              {duration && <span>Took {duration}</span>}
              {startedBy && <span>Started by {startedBy}</span>}
              <span title={`Internal ID ${data.scan_id}`}>
                Scan ID <b style={{ fontFamily: mono, color: p.ink, fontWeight: 600 }}>{scanRef}</b>{' '}
                <button type="button" onClick={() => copy(scanRef, 'id')} style={{ ...btn(p, 'ghost'), padding: 0, fontSize: 12, color: p.blue, display: 'inline' }}>
                  {copied === 'id' ? 'Copied' : 'Copy'}
                </button>
              </span>
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            {vendorId && ctx?.previous && (
              <button type="button" style={btn(p)} onClick={() => navigate(`/vendors/${vendorId}`, { state: { tab: 'overview' } })}
                title="Opens the vendor's scan comparison">Compare with previous scan</button>
            )}
            <Menu p={p} label="Export" items={[
              ...(vendorId ? [{ label: 'PDF report', hint: 'The vendor security report, from Reports', onClick: () => navigate(`/reports?template=vendor-full&vendor=${vendorId}`) }] : []),
              { label: 'Findings (CSV)', hint: `Every finding on ${selectedDomain}`, onClick: () => exportCsv(allIndicators, 'findings') },
              { label: 'Raw data (JSON)', hint: 'The full scan result', onClick: () => downloadFile(`${companyName.replace(/[^\w.-]+/g, '_')}_scan.json`, JSON.stringify(data, null, 2), 'application/json') },
            ]} />
            <button type="button" style={{ ...btn(p), color: p.ai }} disabled={aiSummaryMutation.isPending} onClick={generateSummary}>
              ✦ {aiSummaryMutation.isPending ? 'Writing summary…' : aiSummary ? 'Regenerate AI summary' : 'AI summary'}
            </button>
            {canEdit && (
              <ScanTypeButton label="⟳ Rescan" busy={rescanMutation.isPending} onPick={d => rescanMutation.mutate(d)} isDark={isDark}
                buttonStyle={{ ...btn(p, 'primary') }} />
            )}
          </div>
        </Card>

        {/* 2 Host switcher (deep scans) */}
        {domainResults.length > 1 && (
          <Card p={p} style={{ marginTop: 12, padding: '10px 14px', display: 'flex', alignItems: 'center', gap: 10 }}>
            <span style={{ fontSize: 12, fontWeight: 600, color: p.muted, whiteSpace: 'nowrap' }}>{scanType} · {domainResults.length} hosts</span>
            <div style={{ display: 'flex', gap: 6, overflowX: 'auto', paddingBottom: 2 }}>
              {domainResults.map(dr => {
                const on = dr.domain === selectedDomain;
                const s = Math.round(dr.overall_score || 0);
                return (
                  <button key={dr.domain} type="button" onClick={() => setSelectedDomain(dr.domain)}
                    style={{ display: 'inline-flex', alignItems: 'center', gap: 7, flexShrink: 0, whiteSpace: 'nowrap', borderRadius: 999, padding: '5px 12px',
                      fontFamily: sans, fontSize: 12, cursor: 'pointer', background: on ? p.ink : p.card, color: on ? p.card : p.body,
                      border: `1px solid ${on ? p.ink : p.line}` }}>
                    {dr.domain}
                    {dr.is_primary && <span style={{ fontSize: 9.5, fontWeight: 700, padding: '1px 5px', borderRadius: 4, background: on ? p.card : p.blueBg, color: on ? p.ink : p.blueInk }}>PRIMARY</span>}
                    <b style={{ color: on ? p.card : scoreColor(s) }}>{s}</b>
                  </button>
                );
              })}
            </div>
          </Card>
        )}

        {/* Plan lock */}
        {lockedCount > 0 && (
          <Card p={p} style={{ marginTop: 12, padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
            <span style={{ fontSize: 16 }}>🔒</span>
            <div style={{ flex: 1, minWidth: 220 }}>
              <div style={{ fontSize: 13.5, fontWeight: 600 }}>{lockedCount} checks locked on your plan</div>
              <div style={{ fontSize: 12, color: p.muted }}>Showing {allIndicators.length} of {totalChecks} checks. Upgrade to see every check on every scan.</div>
            </div>
            <button type="button" style={btn(p, 'primary')} onClick={() => navigate('/settings?section=plan')}>Upgrade plan</button>
          </Card>
        )}

        {/* Overview */}
        <div className="sr-overview" style={{ display: 'grid', gridTemplateColumns: 'minmax(0,1.05fr) minmax(0,1.25fr) minmax(0,1fr)', gap: 12, marginTop: 12 }}>
          {/* 3 Rating */}
          <Card p={p} style={{ padding: '18px 20px', display: 'flex', gap: 18, alignItems: 'center' }}>
            <ScoreRing score={score} color={riskColor(riskLevel)} p={p} />
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: 12, color: p.muted }}>Security rating{domainResults.length > 1 ? ` · ${selectedDomain}` : ''}</div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 4, flexWrap: 'wrap' }}>
                <span style={{ fontSize: 22, fontWeight: 700 }}>Grade {grade(score)}</span>
                <Chip color={riskColor(riskLevel)} p={p}>{riskLevel} risk</Chip>
              </div>
              {delta !== null && ctx?.previous && (
                <div style={{ marginTop: 8, fontSize: 12.5, color: p.muted }}>
                  <b style={{ color: delta > 0 ? p.ok : delta < 0 ? '#DC2626' : p.muted }}>{delta > 0 ? `▲ ${delta}` : delta < 0 ? `▼ ${Math.abs(delta)}` : 'No change'}</b>
                  {' '}since the {fmtDate(ctx.previous.date)} scan ({Math.round(ctx.previous.score)})
                </div>
              )}
              {onPrimary && contextQuery.isSuccess && !ctx?.previous && <div style={{ marginTop: 8, fontSize: 12.5, color: p.muted }}>First scan of this vendor</div>}
              {trend.length > 1 && (
                <div style={{ marginTop: 8 }}>
                  <Sparkline points={trend} p={p} />
                  <div style={{ fontSize: 11, color: p.muted }}>Last {trend.length} scans</div>
                </div>
              )}
            </div>
          </Card>

          {/* 4 Severity */}
          <Card p={p} style={{ padding: '18px 20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontSize: 13.5, fontWeight: 700 }}>Open risks by severity</span>
              <span style={{ fontSize: 12, color: p.muted }}>Click to filter</span>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 8, marginTop: 14, textAlign: 'center' }}>
              {SEVERITIES.map(sev => {
                const on = sevFilter.length === 1 && sevFilter[0] === sev && activeTab === 'open';
                const col = SEV_COLOR[sev];
                return (
                  <button key={sev} type="button" onClick={() => showSeverity(sev)} title={`Show ${sev} findings`}
                    style={{ background: 'transparent', border: 'none', cursor: 'pointer', fontFamily: sans, padding: 0 }}>
                    <span style={{ width: 56, height: 56, margin: '0 auto', borderRadius: '50%', border: `3px solid ${col}`, background: on ? tint(col, p) : 'transparent',
                      display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, fontWeight: 700, color: col }}>{sevCounts[sev]}</span>
                    <span style={{ display: 'block', marginTop: 6, fontSize: 12.5, fontWeight: 600, color: p.ink }}>{sev}</span>
                  </button>
                );
              })}
            </div>
            {changes && (changes.new.length + changes.resolved.length + changes.worse.length > 0) && (
              <div style={{ display: 'flex', gap: 8, marginTop: 14, flexWrap: 'wrap' }}>
                {changes.new.length > 0 && (
                  <button type="button" onClick={() => { setTab('open'); setNewOnly(true); scrollToFindings(); }} style={{ background: 'transparent', border: 'none', padding: 0, cursor: 'pointer' }}>
                    <Chip color={p.blue} p={p}>{changes.new.length} new since last scan</Chip>
                  </button>
                )}
                {changes.resolved.length > 0 && <Chip color={p.ok} p={p} title={changes.resolved.join(', ')}>{changes.resolved.length} resolved</Chip>}
                {changes.worse.length > 0 && <Chip color="#EA580C" p={p} title={changes.worse.join(', ')}>{changes.worse.length} got worse</Chip>}
              </div>
            )}
            {changes && changes.new.length + changes.resolved.length + changes.worse.length === 0 && (
              <div style={{ marginTop: 14, fontSize: 12, color: p.muted }}>
                No findings changed since the last scan.{delta ? ' The rating moved because of how the same findings are weighted.' : ''}
              </div>
            )}
          </Card>

          {/* 5 Checks run */}
          <Card p={p} style={{ padding: '18px 20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
              <span style={{ fontSize: 13.5, fontWeight: 700 }}>Checks run</span>
              <span style={{ fontSize: 20, fontWeight: 700 }}>{allIndicators.length.toLocaleString()}</span>
            </div>
            <div style={{ display: 'flex', height: 10, borderRadius: 999, overflow: 'hidden', background: p.line2, marginTop: 14 }} aria-hidden="true">
              <span style={{ width: `${passedPct}%`, background: p.ok }} />
              <span style={{ width: `${openPct}%`, background: '#EA580C' }} />
              <span style={{ width: `${ntPct}%`, background: p.faint }} />
            </div>
            <div style={{ display: 'grid', gap: 7, marginTop: 12, fontSize: 12.5 }}>
              {([['passed', 'Passed', p.ok], ['open', 'Flagged a risk', '#EA580C'], ['nottested', "Couldn't be tested", p.faint]] as const).map(([id, label, col]) => (
                <button key={id} type="button" onClick={() => { setTab(id); scrollToFindings(); }}
                  style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'transparent', border: 'none', padding: 0, cursor: 'pointer', fontFamily: sans, fontSize: 12.5, color: p.body }}>
                  <Dot color={col} />{label}<b style={{ marginLeft: 'auto', color: p.ink }}>{tabCounts[id]}</b>
                </button>
              ))}
            </div>
            <div style={{ fontSize: 11.5, color: lockedCount ? '#B45309' : p.ok, marginTop: 10 }}>
              {lockedCount > 0
                ? <>🔒 {lockedCount} checks locked · <span style={{ color: p.blue, fontWeight: 600, cursor: 'pointer' }} onClick={() => navigate('/settings?section=plan')}>Upgrade</span></>
                : '✓ Every check on your plan ran'}
            </div>
          </Card>
        </div>

        {/* 6 AI executive summary */}
        {(aiSummary || aiSummaryMutation.isPending || aiSummaryError) && (
          <Card p={p} style={{ marginTop: 12, padding: '16px 20px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
              <span style={{ fontSize: 13.5, fontWeight: 700 }}>Executive summary</span>
              <Chip color={p.ai} p={p}>✦ AI drafted</Chip>
              {summaryAt && <span style={{ fontSize: 12, color: p.muted }}>Written {fmtDate(summaryAt, true)}</span>}
              <span style={{ marginLeft: 'auto', display: 'flex', gap: 4 }}>
                {aiSummary && <button type="button" style={btn(p, 'ghost')} onClick={() => copy(aiSummary, 'summary')}>{copied === 'summary' ? 'Copied' : 'Copy'}</button>}
                <button type="button" style={btn(p, 'ghost')} disabled={aiSummaryMutation.isPending} onClick={generateSummary}>Regenerate</button>
                <button type="button" style={btn(p, 'ghost')} onClick={() => setSummaryCollapsed(v => !v)}>{summaryCollapsed ? 'Expand ▾' : 'Collapse ▴'}</button>
              </span>
            </div>
            {!summaryCollapsed && (
              <div style={{ marginTop: 8, fontSize: 13.5, lineHeight: 1.65, color: p.body }}>
                {aiSummaryMutation.isPending ? <span style={{ color: p.muted }}>Writing the summary…</span>
                  : aiSummaryError ? (
                    <span style={{ color: '#DC2626' }}>{aiSummaryError}
                      {/no ai provider|no active api key/i.test(aiSummaryError) && <> <span style={{ color: p.blue, cursor: 'pointer', textDecoration: 'underline' }} onClick={() => navigate('/settings?section=ai-providers')}>Set up an AI provider</span></>}
                    </span>
                  ) : aiSummary}
              </div>
            )}
          </Card>
        )}

        {/* 7 Score by category */}
        {categoryRows.length > 0 && (
          <Card p={p} style={{ marginTop: 12, padding: '16px 20px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12, flexWrap: 'wrap' }}>
              <span style={{ fontSize: 13.5, fontWeight: 700 }}>Score by category</span>
              <span style={{ fontSize: 12, color: p.muted }}>Weakest first · click one to filter the findings</span>
              <span style={{ marginLeft: 'auto', fontSize: 12, color: p.muted }}>{categoryRows.length} categories</span>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(170px, 1fr))', gap: 8 }}>
              {(catsExpanded ? categoryRows : categoryRows.slice(0, 6)).map(r => {
                const col = scoreColor(r.score);
                return (
                  <button key={r.cat} type="button" onClick={() => showCategory(r.cat)} title={`Show ${r.cat} risks`}
                    style={{ textAlign: 'left', border: `1px solid ${catFilter.size === 1 && catFilter.has(r.cat) ? '#185FA5' : p.line}`, borderRadius: 10, padding: '10px 12px',
                      background: p.card, cursor: 'pointer', fontFamily: sans, minWidth: 0 }}>
                    <div style={{ fontSize: 12, color: p.muted, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{r.cat}</div>
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: 6, margin: '4px 0 6px' }}>
                      <b style={{ fontSize: 18, color: col }}>{r.score}</b>
                      <span style={{ fontSize: 12, color: p.muted }}>{r.risks ? `${r.risks} risk${r.risks === 1 ? '' : 's'}` : 'No risks'}</span>
                    </div>
                    <div style={{ height: 6, borderRadius: 999, background: p.line2, overflow: 'hidden' }}><div style={{ width: `${r.score}%`, height: '100%', background: col }} /></div>
                  </button>
                );
              })}
              {categoryRows.length > 6 && (
                <button type="button" onClick={() => setCatsExpanded(v => !v)}
                  style={{ border: `1px dashed ${p.line}`, borderRadius: 10, background: 'transparent', color: p.blue, fontWeight: 600, fontFamily: sans, fontSize: 12.5, cursor: 'pointer', minHeight: 64 }}>
                  {catsExpanded ? 'Show fewer' : `+ ${categoryRows.length - 6} more`}
                </button>
              )}
            </div>
          </Card>
        )}

        {/* 8 Findings */}
        <div id="scan-findings" style={{ marginTop: 20, display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap', scrollMarginTop: 80 }}>
          <h2 style={{ margin: 0, fontSize: 16, fontWeight: 700 }}>Findings</h2>
          <div role="tablist" style={{ display: 'inline-flex', border: `1px solid ${p.line}`, borderRadius: 8, overflow: 'hidden', background: p.card }}>
            {tabs.map(t => {
              const on = activeTab === t.id;
              return (
                <button key={t.id} role="tab" aria-selected={on} type="button" onClick={() => setTab(t.id)}
                  style={{ padding: '7px 12px', fontSize: 12.5, fontWeight: 600, fontFamily: sans, cursor: 'pointer', border: 'none', borderRight: t.id !== 'all' ? `1px solid ${p.line}` : 'none',
                    background: on ? p.ink : 'transparent', color: on ? p.card : p.body }}>
                  {t.label} <span style={{ opacity: 0.75 }}>{tabCounts[t.id]}</span>
                </button>
              );
            })}
          </div>
          {changes && changes.new.length > 0 && (
            <button type="button" onClick={() => setNewOnly(v => !v)} style={{ ...btn(p), borderRadius: 999, padding: '6px 11px',
              ...(newOnly ? { background: p.blueBg, color: p.blueInk, borderColor: p.blueBg } : {}) }}>
              {newOnly ? '✓ ' : ''}New since last scan
            </button>
          )}
          <button type="button" onClick={() => setGroupByCat(v => !v)} style={{ ...btn(p), borderRadius: 999, padding: '6px 11px',
            ...(groupByCat ? { background: p.blueBg, color: p.blueInk, borderColor: p.blueBg } : {}) }}>
            {groupByCat ? '✓ ' : ''}Group by category
          </button>
        </div>

        <div className={showFilterPane ? 'sr-body' : undefined} style={{ display: 'grid', gridTemplateColumns: showFilterPane ? '232px minmax(0,1fr)' : 'minmax(0,1fr)', gap: 12, marginTop: 12, alignItems: 'start' }}>
          {/* 9 Filter rail */}
          {showFilterPane && (
            <Card p={p} style={{ position: 'sticky', top: 80, maxHeight: 'calc(100vh - 100px)', overflowY: 'auto' }}>
              <div style={{ display: 'flex', alignItems: 'center', padding: '14px 16px', borderBottom: `1px solid ${p.line}` }}>
                <span style={{ fontSize: 13.5, fontWeight: 700 }}>Filters</span>
                {activeFilterCount > 0 && <button type="button" onClick={clearFilters} style={{ ...btn(p, 'ghost'), marginLeft: 'auto', padding: 0, color: p.blue, fontSize: 12 }}>Clear</button>}
              </div>
              {activeTab !== 'passed' && activeTab !== 'nottested' && (
                <div style={{ padding: '14px 16px', borderBottom: `1px solid ${p.line2}` }}>
                  <div style={railTitle}>Severity</div>
                  {SEVERITIES.map(sev => (
                    <div key={sev} style={railRow(sevFilter.includes(sev))} onClick={() => toggleSev(sev)}>
                      <Check p={p} checked={sevFilter.includes(sev)} onChange={() => toggleSev(sev)} label={sev} />
                      <Dot color={SEV_COLOR[sev]} />{sev}
                      <span style={{ marginLeft: 'auto', fontSize: 11.5, color: p.faint, fontWeight: 600 }}>{sevInTab[sev]}</span>
                    </div>
                  ))}
                </div>
              )}
              <CatGroup title="Cybersecurity" cats={cyberCats} expanded={cyberExpanded} setExpanded={setCyberExpanded} />
              <CatGroup title="Operational" cats={opsCats} expanded={opsExpanded} setExpanded={setOpsExpanded} />
              <CatGroup title="Other" cats={otherCats} expanded={true} setExpanded={() => undefined} />
            </Card>
          )}

          {/* 10 Table */}
          <Card p={p} style={{ overflow: 'hidden', minWidth: 0 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '12px 14px', borderBottom: `1px solid ${p.line}`, flexWrap: 'wrap' }}>
              <button type="button" onClick={() => setShowFilterPane(v => !v)} aria-pressed={showFilterPane}
                style={{ ...btn(p), ...(showFilterPane ? { background: p.blueBg, color: p.blueInk, borderColor: p.blueBg } : {}) }}>
                ☰ Filters{activeFilterCount ? ` (${activeFilterCount})` : ''}
              </button>
              <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search findings, e.g. TLS or admin panel" aria-label="Search findings"
                style={{ border: `1px solid ${p.line}`, borderRadius: 8, padding: '7px 10px', fontFamily: sans, fontSize: 12.5, width: 270, maxWidth: '100%', background: p.card, color: p.ink, outline: 'none' }} />
              {sevFilter.map(s => (
                <button key={s} type="button" onClick={() => toggleSev(s)} style={{ background: 'transparent', border: 'none', padding: 0, cursor: 'pointer' }} title="Remove filter">
                  <Chip color={SEV_COLOR[s]} p={p} style={{ padding: '5px 10px' }}>{s} ✕</Chip>
                </button>
              ))}
              {Array.from(catFilter).slice(0, 3).map(cat => (
                <button key={cat} type="button" onClick={() => setCatFilter(prev => toggleIn(prev, cat))} style={{ background: 'transparent', border: 'none', padding: 0, cursor: 'pointer' }} title="Remove filter">
                  <Chip color={p.blue} p={p} style={{ padding: '5px 10px' }}>{cat} ✕</Chip>
                </button>
              ))}
              {catFilter.size > 3 && <span style={{ fontSize: 12, color: p.muted }}>+{catFilter.size - 3} categories</span>}
              <span style={{ marginLeft: 'auto', display: 'flex', gap: 6 }}>
                <Menu p={p} label={`Sort: ${({ risk: 'Highest risk', 'risk-asc': 'Lowest risk', name: 'Name', category: 'Category', first: 'Newest first' } as Record<SortKey, string>)[sortKey]}`}
                  items={([['risk', 'Highest risk'], ['risk-asc', 'Lowest risk'], ['name', 'Name A–Z'], ['category', 'Category'], ['first', 'Newest first detected']] as [SortKey, string][])
                    .map(([k, l]) => ({ label: (k === sortKey ? '✓ ' : '') + l, onClick: () => setSortKey(k) }))} />
                <Menu p={p} label="Columns" items={(Object.keys(cols) as (keyof typeof cols)[]).filter(k => k !== 'indicator').map(k => ({
                  label: `${cols[k] ? '✓ ' : ''}${({ riskScore: 'Risk', category: 'Category', status: 'Status', firstDetected: 'First detected', lastDetected: 'Last checked', source: 'Source' } as Record<string, string>)[k]}`,
                  onClick: () => setCols(prev => ({ ...prev, [k]: !prev[k] })),
                }))} />
                <button type="button" style={btn(p)} onClick={() => exportCsv(filtered, 'findings')}>Export CSV</button>
              </span>
            </div>

            {selected.size > 0 && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '9px 14px', background: p.sel, borderBottom: `1px solid ${p.line}`, flexWrap: 'wrap' }}>
                <b style={{ fontSize: 12.5 }}>{selected.size} selected</b>
                {canEdit && vendorId && (
                  <button type="button" style={{ ...btn(p), padding: '5px 10px' }} disabled={!selectedOpen.length}
                    title={selectedOpen.length ? undefined : 'Only open risks can go in a remediation request'}
                    onClick={() => setRemediateNames(Array.from(new Set(selectedOpen.map(i => i.indicator_name))))}>
                    Request remediation{selectedOpen.length !== selected.size && selectedOpen.length ? ` (${selectedOpen.length})` : ''}
                  </button>
                )}
                {canEdit && (
                  <button type="button" style={{ ...btn(p), padding: '5px 10px' }} disabled={recheckMutation.isPending} onClick={() => recheckMutation.mutate(selectedInds)}>
                    {recheckMutation.isPending ? 'Starting re-checks…' : 'Re-check now'}
                  </button>
                )}
                <button type="button" style={{ ...btn(p, 'ghost'), padding: '5px 10px' }} onClick={() => exportCsv(selectedInds, 'selected_findings')}>Export selected</button>
                <button type="button" style={{ ...btn(p, 'ghost'), padding: '5px 10px', marginLeft: 'auto' }} onClick={() => setSelected(new Set())}>Clear selection</button>
              </div>
            )}

            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 760 }}>
                <thead>
                  <tr>
                    <th style={{ ...th, width: 36 }}>
                      <Check p={p} checked={allOnPage} partial={!allOnPage && someOnPage} label="Select all on this page"
                        onChange={() => setSelected(prev => { const n = new Set(prev); pageKeys.forEach(k => (allOnPage ? n.delete(k) : n.add(k))); return n; })} />
                    </th>
                    {cols.riskScore && <th style={{ ...th, width: 88 }}>Risk</th>}
                    <th style={th}>Finding</th>
                    {cols.category && <th style={th}>Category</th>}
                    {cols.status && <th style={{ ...th, width: 120 }}>Status</th>}
                    {cols.firstDetected && <th style={th}>First detected</th>}
                    {cols.lastDetected && <th style={th}>Last checked</th>}
                    {cols.source && <th style={th}>Source</th>}
                    <th style={{ ...th, width: 28 }} aria-label="Open" />
                  </tr>
                </thead>
                <tbody>
                  {pageItems.length === 0 ? (
                    <tr><td colSpan={9} style={{ ...td, textAlign: 'center', padding: '48px 16px', color: p.muted }}>
                      {activeTab === 'open' && tabCounts.open === 0 && !activeFilterCount ? 'No open risks on this host. Every check passed or couldn\'t be tested.' : 'No findings match your filters.'}
                      {activeFilterCount > 0 && <> <button type="button" onClick={clearFilters} style={{ ...btn(p, 'ghost'), color: p.blue, display: 'inline', padding: 0 }}>Clear filters</button></>}
                    </td></tr>
                  ) : pageItems.map((ind, idx) => {
                    const k = keyOf(ind);
                    const state = stateOf.get(k) || { label: 'Passed', color: p.ok };
                    const risk = checkRisk(ind);
                    const color = ind.deprioritized ? p.faint : state.color;
                    const isSel = selected.has(k);
                    const prevCat = idx > 0 ? pageItems[idx - 1].category : null;
                    const rem = vendorId && onPrimary ? (inRemediation as any)[ind.indicator_name] : null;
                    const checkKey = ind.evidence && typeof ind.evidence === 'object' ? ind.evidence.indicator : null;
                    const src = getSrc(ind);
                    return (
                      <React.Fragment key={`${k}-${idx}`}>
                        {groupByCat && ind.category !== prevCat && (
                          <tr><td colSpan={9} style={{ ...td, background: p.sunken, fontSize: 12, fontWeight: 700, color: p.muted, padding: '8px 12px' }}>
                            {ind.category} <span style={{ fontWeight: 600, color: p.faint }}>· {filtered.filter(i => i.category === ind.category).length}</span>
                          </td></tr>
                        )}
                        <tr onClick={() => setSelInd(ind)} style={{ cursor: 'pointer', background: isSel ? p.sel : selInd && keyOf(selInd) === k ? p.hover : 'transparent' }}
                          onMouseEnter={e => { if (!isSel) e.currentTarget.style.background = p.hover; }}
                          onMouseLeave={e => { e.currentTarget.style.background = isSel ? p.sel : 'transparent'; }}>
                          <td style={td}><Check p={p} checked={isSel} label={`Select ${ind.indicator_name}`} onChange={() => setSelected(prev => toggleIn(prev, k))} /></td>
                          {cols.riskScore && (
                            <td style={td}>
                              {state.label === 'Not tested' ? <span style={{ color: p.faint }}>—</span> : (
                                <span title={`The check rated this ${risk} out of 10 (0 = no risk, 10 = severe)`}
                                  style={{ display: 'inline-flex', alignItems: 'baseline', justifyContent: 'center', gap: 2, minWidth: 54, height: 28, lineHeight: '28px', padding: '0 8px',
                                    boxSizing: 'border-box', borderRadius: 6, background: tint(color, p), border: `1px solid ${color}33`, color, whiteSpace: 'nowrap' }}>
                                  <span style={{ fontSize: 13.5, fontWeight: 700 }}>{risk}</span><span style={{ fontSize: 10.5, fontWeight: 600, opacity: 0.7 }}>/ 10</span>
                                </span>
                              )}
                            </td>
                          )}
                          <td style={{ ...td, minWidth: 220 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                              <span style={{ fontSize: 13, fontWeight: 600, color: p.ink }}>{ind.indicator_name}</span>
                              {onPrimary && newSet.has(ind.indicator_name) && <span style={{ fontSize: 10, fontWeight: 700, padding: '1px 6px', borderRadius: 4, background: p.blueBg, color: p.blueInk }}>NEW</span>}
                              {onPrimary && worseSet.has(ind.indicator_name) && <Chip color="#EA580C" p={p} style={{ fontSize: 10, padding: '1px 6px' }}>▲ worse</Chip>}
                              {rem && <Chip color={p.ai} p={p} style={{ fontSize: 10, padding: '1px 6px' }} title={rem.title}>In remediation</Chip>}
                              {ind.deprioritized && <Chip color={p.faint} p={p} style={{ fontSize: 10, padding: '1px 6px' }} title="Non-production host, not scored">Not scored</Chip>}
                            </div>
                            {checkKey && <div style={{ fontSize: 11, color: p.faint, marginTop: 2, fontFamily: mono }}>{checkKey}</div>}
                          </td>
                          {cols.category && <td style={{ ...td, fontSize: 12, color: p.muted }}>{ind.category}</td>}
                          {cols.status && (
                            <td style={td}><Chip color={state.color} p={p}><Dot color={state.color} />{state.label}</Chip></td>
                          )}
                          {cols.firstDetected && <td style={{ ...td, fontSize: 12, color: p.muted, whiteSpace: 'nowrap' }}>{fmtDate(ind.first_seen || completedAt)}</td>}
                          {cols.lastDetected && <td style={{ ...td, fontSize: 12, color: p.muted, whiteSpace: 'nowrap' }}>{fmtDate(completedAt)}</td>}
                          {cols.source && <td style={{ ...td, fontSize: 12, color: p.muted }}>{src || '—'}</td>}
                          <td style={{ ...td, color: p.faint, fontSize: 16 }}>›</td>
                        </tr>
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 14px', fontSize: 12, color: p.muted, flexWrap: 'wrap', borderTop: `1px solid ${p.line2}` }}>
              <span>{filtered.length ? `Showing ${(safePage - 1) * perPage + 1}–${Math.min(safePage * perPage, filtered.length)} of ${filtered.length}` : 'No findings'}</span>
              <span style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 8 }}>
                Rows per page
                <select value={perPage} onChange={e => setPerPage(Number(e.target.value))} aria-label="Rows per page"
                  style={{ border: `1px solid ${p.line}`, borderRadius: 6, padding: '4px 8px', fontSize: 12, background: p.card, color: p.ink, fontFamily: sans }}>
                  {[10, 25, 50, 100].map(n => <option key={n} value={n}>{n}</option>)}
                </select>
              </span>
              <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <button type="button" style={{ ...btn(p), padding: '4px 10px' }} disabled={safePage <= 1} onClick={() => setPage(safePage - 1)} aria-label="Previous page">‹</button>
                <span style={{ minWidth: 64, textAlign: 'center', color: p.ink, fontWeight: 600 }}>{safePage} of {totalPages}</span>
                <button type="button" style={{ ...btn(p), padding: '4px 10px' }} disabled={safePage >= totalPages} onClick={() => setPage(safePage + 1)} aria-label="Next page">›</button>
              </span>
            </div>
          </Card>
        </div>
      </div>

      <style>{`
        @media (max-width: 1100px) { .sr-overview { grid-template-columns: minmax(0,1fr) minmax(0,1fr) !important; } }
        @media (max-width: 760px) { .sr-overview { grid-template-columns: minmax(0,1fr) !important; } .sr-body { grid-template-columns: minmax(0,1fr) !important; } }
      `}</style>
    </div>
  );
}
